module.exports = {
	"title": "Werkgever aansprakelijkheid",
	"edges": [
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BV1295_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BV1295"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA7217_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA7217"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX7590",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX7590",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ4850",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ4850",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB6178",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB6178",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD299",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD299",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9344",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9344",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6526_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6526"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC272",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC272",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9225",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9225",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BO1799_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BO1799"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1976:AC5837",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1976:AC5837",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1969:AC4973",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1969:AC4973",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF0003_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF0003"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN7324",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN7324",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AC3826",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AC3826",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9313",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9313",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE9242",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE9242",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1983:AG4611",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1983:AG4611",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1430_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9048",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9048",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1430"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BU7412",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BU7412",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BO3935",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BO3935",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2006:AY0534",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2006:AY0534",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2004:AR5022",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2004:AR5022",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BL0510",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BL0510",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI6323_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC7683",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC7683",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI6323"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1044",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1044",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9243",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9243",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AC4282",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AC4282",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD9124_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0394",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0394",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD9124"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2495",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2495",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AC0442",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AC0442",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI1508_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AR6657",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AR6657",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI1508"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC6699_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF3422",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF3422",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC6699"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2149",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2149",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA7686",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA7686",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8364",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8364",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1994:ZC1405",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1994:ZC1405",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD7319",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD7319",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO7817",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO7817",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD4923_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD4923"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:1996:AD4440",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:1996:AD4440",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB7191_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AP0965",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AP0965",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB7191"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC0073",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC0073",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0352",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0352",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ7863_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0526",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0526",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ7863"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI4209_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BE7201",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BE7201",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI4209"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9308_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AD0808",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AD0808",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9308"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3835",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3835",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX0598",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX0598",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1076",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1076",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9705_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU9717",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU9717",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9705"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1208",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1208",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2748",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2748",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC293",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC293",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BH1996",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BH1996",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:644_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN3831",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN3831",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:644"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC8398",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC8398",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4224",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4224",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1978:AC3514",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1978:AC3514",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2460",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2460",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5634_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5634"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU2235_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU2235"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF5891_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC2912",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC2912",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF5891"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596"
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI9632_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9173",
			"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9173",
			"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI9632"
		}
	],
	"nodes": [
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 690",
				"Burgerlijk Wetboek Boek 7 610"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Toepasselijkheid CAO's uitzendbranche. Overeenkomst waarbij een onderneming bemiddelt bij de plaatsing van MBO-leerlingen in leerbedrijven in het kader van in het onderwijs verplichte stages. Gaan de leerlingen een arbeidsovereenkomst aan? Motiveringsgebrek.",
			"authorities": 0,
			"hubs": 8.75865925256645e-72,
			"community": "10",
			"ecli": "ECLI:NL:HR:2015:3019",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2015-10-09",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 7,
			"x": 0.02987929754987806,
			"y": 0.7496325701649635,
			"title": "ECLI:NL:HR:2015:3019 Hoge Raad , 09-10-2015 / 14/03393",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2015
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:644",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 6,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Burgerlijk Wetboek Boek 6 129",
				"Invorderingswet 1990",
				"Invorderingswet 1990 38",
				"Burgerlijk Wetboek Boek 6",
				"Burgerlijk Wetboek Boek 6 127"
			],
			"in_degree": 0,
			"abstract": "Artikel 38 Invorderingswet 1990. Aansprakelijkstelling werknemer voor niet door werkgever ingehouden loonbelasting. Interne compensatie door ontvanger.",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "27",
			"ecli": "ECLI:NL:HR:2015:644",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2015-03-20",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 7,
			"x": 0.7754500135230601,
			"y": 0.43450911131100023,
			"title": "ECLI:NL:HR:2015:644 Hoge Raad , 20-03-2015 / 13/04344",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#bestuursrecht_belastingrecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2015
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"6:74 bw",
				"Wetboek van Burgerlijke Rechtsvordering",
				"Burgerlijk Wetboek Boek 7 658",
				"Wetboek van Burgerlijke Rechtsvordering 25",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 611",
				"Burgerlijk Wetboek Boek 6 74",
				"Burgerlijk Wetboek Boek 6"
			],
			"in_degree": 0,
			"abstract": "Werkgeversaansprakelijkheid. Art. 7:658 BW. Zorgplicht werkgever. Aanvullende veiligheidsmaatregelen indien de plaats van werkzaamheden belet dat werkgever toezicht houdt op naleving van instructies? HR 7 december 2012, ECLI:NL:HR:2012:BX7590, NJ 2013/11. Mate waarin werkgever toezicht moet houden op naleving instructies. Hoge eisen aan stelplicht werkgever? Onderscheid met HR 11 november 2011, ECLI:NL:HR:2011:BR5223, NJ 2011/598. Omstandigheden van het geval. Verwijt dat werkgever in strijd met cao geen ongevallenverzekering heeft afgesloten; art. 6:74 BW; aanvulling rechtsgronden.",
			"authorities": 0,
			"hubs": 8.75865925256645e-72,
			"community": "2",
			"ecli": "ECLI:NL:HR:2014:3519",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2014-12-05",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.053277835587929236,
			"count_version": 8,
			"x": 0.7550405894812772,
			"y": 0.7795141268483574,
			"title": "ECLI:NL:HR:2014:3519 Hoge Raad , 05-12-2014 / 13/03613",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2014
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 5,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 1019bb",
				"Wetboek van Burgerlijke Rechtsvordering 1019aa",
				"Wetboek van Burgerlijke Rechtsvordering 1019w",
				"Wetboek van Burgerlijke Rechtsvordering 1019cc",
				"Wetboek van Burgerlijke Rechtsvordering"
			],
			"in_degree": 0,
			"abstract": "Deelgeschilprocedure, art. 1019w Rv. Doorbreking rechtsmiddelenverbod van art. 1019bb Rv? Doorbrekingsjurisprudentie van overeenkomstige toepassing? Vormt het rechtsmiddel, bedoeld in art. 1019cc lid 3 Rv aanleiding om doorbreking niet toe te staan? HR 28 september 2012, ECLI:NL:HR:2012:BX0598, NJ 2012/556. Levert stelling dat beëindiging deelgeschil niet kan bijdragen aan totstandkoming vaststellingsovereenkomst doorbrekingsgrond op? HR 24 september 1993, ECLI:NL:HR:1993:ZC1076, NJ 1993/758. Proceskosten in cassatie; art. 1019aa Rv.",
			"authorities": 0,
			"hubs": 8.75865925256645e-72,
			"community": "23",
			"ecli": "ECLI:NL:HR:2014:943",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2014-04-18",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 11,
			"x": 0.841335400674125,
			"y": 0.36903970667494834,
			"title": "ECLI:NL:HR:2014:943 Hoge Raad , 18-04-2014 / 13/01106",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2014
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721",
			"out_degree_centrality": 0.03870967741935484,
			"degree_centrality": 0.03870967741935484,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Wetboek van Burgerlijke Rechtsvordering",
				"Burgerlijk Wetboek Boek 7 658",
				"Burgerlijk Wetboek Boek 6 99",
				"Wetboek van Burgerlijke Rechtsvordering 150",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 6 101",
				"Burgerlijk Wetboek Boek 6",
				"Burgerlijk Wetboek Boek 6 98"
			],
			"in_degree": 0,
			"abstract": "\n         Werkgeversaansprakelijkheid wegens blootstelling aan gevaarlijke stoffen, art. 7:658 BW. Causaal verband, omkeringsregel, stelplicht en  bewijslast (HR 17 november 2000, LJN AA8369, NJ 2001/596, Unilever/[A], HR 23 juni 2006, LJN AW6166, NJ 2006/354, [B/C], en HR 9 januari 2009, LJN BF8875, NJ 2011/252, [D]/BAM). Grootte van de kans op veroorzaking door gestelde blootstelling mede van belang. Onzekerheid of onbepaaldheid van het verband tussen gezondheidsschade en arbeidsomstandigheden. Kenbaarheid van gevaren ten tijde van de blootstelling? Omvang zorgplicht werkgever, voorzorgsmaatregelen, omstandigheden van het geval. Proportionele aansprakelijkheid, oorzaak die voor risico van benadeelde zelf komt (HR 31 maart 2006, LJN AU6092, NJ 2011/250).",
			"authorities": 0,
			"hubs": 0.19199218276297386,
			"community": "0",
			"ecli": "ECLI:NL:HR:2013:BZ1721",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2013-06-07",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.04778972520908004,
			"count_version": 9,
			"x": 0.5342422767095781,
			"y": 0.028789163304819065,
			"title": "ECLI:NL:HR:2013:BZ1721 Hoge Raad , 07-06-2013 / 12/03390",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 6,
			"degree": 6,
			"year": 2013
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717",
			"out_degree_centrality": 0.03225806451612903,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Wetboek van Burgerlijke Rechtsvordering",
				"Burgerlijk Wetboek Boek 7 658",
				"Burgerlijk Wetboek Boek 6 99",
				"Wetboek van Burgerlijke Rechtsvordering 150",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 6 101",
				"Burgerlijk Wetboek Boek 6"
			],
			"in_degree": 0,
			"abstract": "\n         Werkgeversaansprakelijkheid voor RSI;, art. 7:658 BW. Zorgplicht werkgever, art. 4 Besluit beeldschermwerk; inlichtingenplicht werkgever over aard werkzaamheden en daaraan verbonden gevaren en maatregelen ter voorkoming of beperking gevaren, art. 6 lid 1 Arbeidsomstandighedenwet 1994.  Causaal verband, omkeringsregel, stelplicht en  bewijslast (HR 17 november 2000, LJN AA8369, NJ 2001/596, Unilever/[A], HR 23 juni 2006, LJN AW6166, NJ 2006/354, [B/C], en HR 9 januari 2009, LJN BF8875, NJ 2011/252, [D]/BAM). Onzekerheid of onbepaaldheid van het verband tussen gezondheidsschade en arbeidsomstandigheden; onduidelijkheid omtrent aard en oorzaak van gestelde gezondheidsklachten. Geen proportionele aansprakelijkheid (HR 31 maart 2006, LJN AU6092, NJ 2011/250). Vaststelling van verband tussen gezondheidsklachten en arbeidsomstandigheden oordeel van feitelijke aard.",
			"authorities": 0,
			"hubs": 0.1739452989471851,
			"community": "0",
			"ecli": "ECLI:NL:HR:2013:BZ1717",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2013-06-07",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0469208211143695,
			"count_version": 8,
			"x": 0.5834857221275371,
			"y": 0.8718783773185426,
			"title": "ECLI:NL:HR:2013:BZ1717 Hoge Raad , 07-06-2013 / 12/01939",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 5,
			"degree": 5,
			"year": 2013
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780",
			"out_degree_centrality": 0.03225806451612903,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 4,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:663 bw",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 663",
				"Burgerlijk Wetboek Boek 7 662"
			],
			"in_degree": 0,
			"abstract": "Overgang van onderneming in de zin van art. 7:663 BW; voortzetting dienstverband met verkrijgende partij. Werknemer in dienst van personeelsvennootschap maar tewerkgesteld bij tot hetzelfde concern behorende andere vennootschap, wier onderneming wordt overgedragen. Richtlijnconforme uitleg van “werkgever” (art. 7:663 BW) in licht van art. 3 Richtlijn 2001/23/EG. Bedoeling van wetgever; algemene rechtsbeginselen, rechtszekerheidsbeginsel, verbod van terugwerkende kracht, contra legem-uitleg.",
			"authorities": 0,
			"hubs": 2.3409835357982093e-38,
			"community": "20",
			"ecli": "ECLI:NL:HR:2013:BZ1780",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2013-04-05",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.03225806451612903,
			"count_version": 9,
			"x": 0.8181708111809385,
			"y": 0.7450794496272304,
			"title": "ECLI:NL:HR:2013:BZ1780 Hoge Raad , 05-04-2013 / 12/00667",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 5,
			"degree": 5,
			"year": 2013
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX7590",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 1,
			"abstract": "Arubaanse zaak. Zorgverplichting werkgever, aansprakelijkheid; toezicht op naleving veiligheidsmaatregelen door (ervaren) werknemers. Beschikbaarheid veiligheidsmateriaal; instructies door werkgever. Art. 7A:1614x BWA (art. 7:658 BW).",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "2",
			"ecli": "ECLI:NL:HR:2012:BX7590",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "2012-12-07",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.14285714285714285,
			"closeness_centrality": 0,
			"count_version": 7,
			"x": 0.22151717541163396,
			"y": 0.7466617017044543,
			"title": "ECLI:NL:HR:2012:BX7590 Hoge Raad , 07-12-2012 / 11/05535",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2012
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX0598",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"10 evrm"
			],
			"in_degree": 1,
			"abstract": "(Appel)procesrecht. Recht op pleidooi in incident; art. 134, 208 en 353 Rv. Appelverbod van art. 337 lid 2 Rv; toepasselijkheid ‘doorbrekingsjurisprudentie’; gronden voor doorbreking wettelijk appelverbod. Art. 10 EVRM.",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "23",
			"ecli": "ECLI:NL:HR:2012:BX0598",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "2012-09-28",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.125,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.5202191825928794,
			"y": 0.21833970074123765,
			"title": "ECLI:NL:HR:2012:BX0598 Hoge Raad , 28-09-2012 / 11/03974",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2012
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BV1295",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:611 bw",
				"Burgerlijk Wetboek Boek 7 685",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 611"
			],
			"in_degree": 0,
			"abstract": "Uitleg dekkingsomvang AVB-polis. Aansprakelijkheid werkgever bij verkeersongeval werknemer op grond van art. 7:611 BW (verzekeringsplicht niet nagekomen). Is schade werknemer letselschade in zin van polis? Functie AVB-polis en daarop gebaseerde verwachtingen rechtvaardigen ruime uitleg dekkingsomvang; dekking tegen aansprakelijkheid voor letselschade omvat in beginsel ook dekking tegen op art. 7:611 gebaseerde aansprakelijkheid.",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "2",
			"ecli": "ECLI:NL:HR:2012:BV1295",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2012-03-30",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.03870967741935484,
			"count_version": 8,
			"x": 0.5914288260235278,
			"y": 0.3948126445905893,
			"title": "ECLI:NL:HR:2012:BV1295 Hoge Raad , 30-03-2012 / 11/01010",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2012
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BU7412",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:2 bw",
				"6:2 bw",
				"Burgerlijk Wetboek Boek 7 2",
				"Burgerlijk Wetboek Boek 6 2",
				"Burgerlijk Wetboek Boek 3 296",
				"Burgerlijk Wetboek Boek 3 39",
				"Burgerlijk Wetboek Boek 6",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 3"
			],
			"in_degree": 1,
			"abstract": "Cassatie in belang der wet. Koop. Ook aan particuliere verkoper komt jegens particuliere koper beroep toe op schriftelijkheidsvereiste art. 7:2 lid 1 BW. Medewerking aan schriftelijke vastlegging kan niet met rechterlijk vonnis worden afgedwongen. Vordering tot schadevergoeding evenmin toewijsbaar. Beroep op art. 6:2 lid 2 BW alleen onder zeer bijzondere omstandigheden. In dat geval slechts veroordeling tot schadevergoeding mogelijk.",
			"authorities": 1.6236909940434693e-38,
			"hubs": 0,
			"community": "20",
			"ecli": "ECLI:NL:HR:2011:BU7412",
			"pagerank": 0.004491219658822496,
			"betweenness_centrality": 0,
			"date": "2011-12-09",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.1,
			"closeness_centrality": 0,
			"count_version": 8,
			"x": 0.5711896553621079,
			"y": 0.6628610333561578,
			"title": "ECLI:NL:HR:2011:BU7412 Hoge Raad , 09-12-2011 / 11/03863 (CW 2629)",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2011
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223",
			"out_degree_centrality": 0.03225806451612903,
			"degree_centrality": 0.03870967741935484,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:611 bw",
				"7:658 bw",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 611",
				"Burgerlijk Wetboek Boek 7 658"
			],
			"in_degree": 1,
			"abstract": "Werkgeversaansprakelijkheid. Letsel werknemer door geweldsdelict tijdens uitvoering werkzaamheden in TBS-instelling. Ongeval dat voortvloeit uit gevaarzettende situatie die rechtstreeks verband houdt met en inherent is aan uitvoering werkzaamheden waaraan werknemer zich niet kan onttrekken. In geval als onderhavige hoge eisen stelplicht werkgever dat hij in art. 7:658 lid 1 BW bedoelde maatregelen is nagekomen. Temeer nu ambtenaar met soortgelijke functie op grond van art. 69 lid 2 ARAR recht heeft op volledige schadevergoeding. Hof heeft miskend dat werkgever niet aan stelplicht en bewijslast heeft voldaan. Art. 7:658 geen absolute waarborg voor bescherming werknemer. Daarmee strookt niet bij “structureel gevaarlijk werk” aansprakelijkheid uit hoofde van goed werkgeverschap (art. 7:611 BW) aan te nemen indien werkgever uit art. 7:658 voortvloeiende verplichtingen is nagekomen. Op art. 7:611 BW gebaseerde verzekeringsverplichting niet ook in onderhavig geval; afbakening tot verkeersongevallen (vgl. HR 11 november 2011, nr. 10/04875).",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0.0035351501650317716,
			"community": "2",
			"ecli": "ECLI:NL:HR:2011:BR5223",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0.0012568077084206116,
			"date": "2011-11-11",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.09090909090909091,
			"closeness_centrality": 0.06311360448807854,
			"count_version": 9,
			"x": 0.3815432967340322,
			"y": 0.9728451661984117,
			"title": "ECLI:NL:HR:2011:BR5223 Hoge Raad , 11-11-2011 / 10/04571",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 5,
			"degree": 6,
			"year": 2011
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215",
			"out_degree_centrality": 0.03225806451612903,
			"degree_centrality": 0.03870967741935484,
			"count_annotation": 4,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 611",
				"Burgerlijk Wetboek Boek 7 658"
			],
			"in_degree": 1,
			"abstract": "Werkgeversaansprakelijkheid. Letsel werknemer door uitglijden tijdens te voet bezorgen van post. Uit goed werkgeverschap voortvloeiende verzekeringsverplichting beperkt tot verkeersongevallen. Algemene verzekeringsplicht in strijd met strekking art. 7:658 BW. Taak wetgever; algemene regeling voor bescherming tegen risico van ongevallen gaat rechtsvormende taak rechter te buiten. Afbakening verzekeringsverplichting nodig met oog op rechtszekerheid en hanteerbaarheid recht.",
			"authorities": 1.570337572619915e-96,
			"hubs": 0.0037281970513766936,
			"community": "2",
			"ecli": "ECLI:NL:HR:2011:BR5215",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0.0009635525764558023,
			"date": "2011-11-11",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.08333333333333333,
			"closeness_centrality": 0.04740143369175626,
			"count_version": 9,
			"x": 0.49857872641021583,
			"y": 0.10555493915933245,
			"title": "ECLI:NL:HR:2011:BR5215 Hoge Raad , 11-11-2011 / 10/04875",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 5,
			"degree": 6,
			"year": 2011
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514",
			"out_degree_centrality": 0.03225806451612903,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 658"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Schade werknemer als gevolg van blootstelling tijdens uitoefening werkzaamheden aan voor de gezondheid gevaarlijke concentratie van stoffen. Stelplicht en bewijslastverdeling. Ingevolge art. 7:658 lid 2 BW dient de werknemer te stellen en zo nodig te bewijzen gedurende zijn werkzaamheden te zijn blootgesteld aan voor de gezondheid gevaarlijke stoffen en aannemelijk te maken dat hij lijdt aan een ziekte of gezondheidsklacht die door die blootstelling kan zijn veroorzaakt (vgl. HR 17 november 2000, NJ 2001/596). Beoordeling rapport deskundige. Rechter dient ter beantwoording van de vraag of hij de conclusies van deskundige zal volgen, alle ter zake door partijen aangevoerde feiten en omstandigheden in aanmerking te nemen en op basis van die aangevoerde stellingen in volle omvang te toetsen of aanleiding bestaat van de in het rapport geformuleerde conclusies af te wijken.",
			"authorities": 0,
			"hubs": 0.1686404843774492,
			"community": "0",
			"ecli": "ECLI:NL:HR:2011:BQ3514",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2011-07-08",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0380513495720869,
			"count_version": 7,
			"x": 0.18533088302002598,
			"y": 0.6682680599969092,
			"title": "ECLI:NL:HR:2011:BQ3514 Hoge Raad , 08-07-2011 / 10/00425",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 5,
			"degree": 5,
			"year": 2011
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519",
			"out_degree_centrality": 0.01935483870967742,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 658"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Schade werknemer als gevolg van blootstelling tijdens uitoefening werkzaamheden aan voor de gezondheid gevaarlijke concentratie van stoffen. Stelplicht en bewijslastverdeling. Ingevolge art. 7:658 lid 2 BW dient de werknemer te stellen en zo nodig te bewijzen gedurende zijn werkzaamheden te zijn blootgesteld aan voor de gezondheid gevaarlijke stoffen en aannemelijk te maken dat hij lijdt aan een ziekte of gezondheidsklacht die door die blootstelling kan zijn veroorzaakt (vgl. HR 17 november 2000, NJ 2001/596). Beoordeling rapport deskundige. Rechter dient ter beantwoording van de vraag of hij de conclusies van deskundige zal volgen, alle ter zake door partijen aangevoerde feiten en omstandigheden in aanmerking te nemen en op basis van die aangevoerde stellingen in volle omvang te toetsen of aanleiding bestaat van de in het rapport geformuleerde conclusies af te wijken.",
			"authorities": 0,
			"hubs": 0.06583819041971194,
			"community": "0",
			"ecli": "ECLI:NL:HR:2011:BQ3519",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2011-07-08",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.01935483870967742,
			"count_version": 5,
			"x": 0.3529768768594268,
			"y": 0.7284771009369668,
			"title": "ECLI:NL:HR:2011:BQ3519 Hoge Raad , 08-07-2011 / 10/00430",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 3,
			"degree": 3,
			"year": 2011
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517",
			"out_degree_centrality": 0.01935483870967742,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Schade werknemer als gevolg van blootstelling tijdens uitoefening werkzaamheden aan voor de gezondheid gevaarlijke concentratie van stoffen. Stelplicht en bewijslastverdeling. Ingevolge art. 7:658 lid 2 BW dient de werknemer te stellen en zo nodig te bewijzen gedurende zijn werkzaamheden te zijn blootgesteld aan voor de gezondheid gevaarlijke stoffen en aannemelijk te maken dat hij lijdt aan een ziekte of gezondheidsklacht die door die blootstelling kan zijn veroorzaakt (vgl. HR 17 november 2000, NJ 2001/596). Beoordeling rapport deskundige. Rechter dient ter beantwoording van de vraag of hij de conclusies van deskundige zal volgen, alle ter zake door partijen aangevoerde feiten en omstandigheden in aanmerking te nemen en op basis van die aangevoerde stellingen in volle omvang te toetsen of aanleiding bestaat van de in het rapport geformuleerde conclusies af te wijken.",
			"authorities": 0,
			"hubs": 0.06583819041971194,
			"community": "0",
			"ecli": "ECLI:NL:HR:2011:BQ3517",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2011-07-08",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.01935483870967742,
			"count_version": 3,
			"x": 0.4907846092437922,
			"y": 0.9161858992477155,
			"title": "ECLI:NL:HR:2011:BQ3517 Hoge Raad , 08-07-2011 / 10/00428",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 3,
			"degree": 3,
			"year": 2011
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 166",
				"Wetboek van Burgerlijke Rechtsvordering",
				"Burgerlijk Wetboek Boek 7 658",
				"Wetboek van Burgerlijke Rechtsvordering 150",
				"Algemene wet gelijke behandeling",
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 611",
				"Algemene wet gelijke behandeling 10"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht/Procesrecht. Vordering tot vergoeding op de voet van art. 7:611 en 7:658 BW tot vergoeding van als gevolg van discriminatie geleden schade. Aanbod aanvullend bewijs te leveren op ontoereikende gronden gepasseerd. Hoger beroep kan dienen om eigen fouten en vergissingen te herstellen. Het kan ook dienen om aanvullend bewijs te leveren als de eerste rechter het reeds bijgebrachte bewijs onvoldoende zwaarwegend heeft geacht. Van appellant die bij memorie van grieven nader bewijs aanbiedt, daarbij gebruikmakend van de gelegenheid tot verbetering of aanvulling van hetgeen hij in eerste aanleg heeft gedaan of nagelaten, kan in beginsel niet worden gevergd dat hij een rechtvaardiging geeft van zijn eerdere verzuim (vgl. HR 1 maart 2002, NJ 2003/355). Te hoge eisen aan (specificatie van) bewijsaanbod.",
			"authorities": 0,
			"hubs": 8.75865925256645e-72,
			"community": "11",
			"ecli": "ECLI:NL:HR:2011:BP9991",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2011-05-27",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 7,
			"x": 0.09721814629199965,
			"y": 0.35481552661979243,
			"title": "ECLI:NL:HR:2011:BP9991 Hoge Raad , 27-05-2011 / 10/02358",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2011
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BO1799",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "Verbintenissenrecht. Beheerovereenkomst. Zorgplicht vermogensbeheerder. Causaliteitsonzekerheid. Op de vermogensbeheerder, als ter zake bij uitstek professionele en deskundige partij, rust naar de aard van de tussen partijen gesloten beheerovereenkomst een bijzondere op de eisen van redelijkheid en billijkheid gebaseerde, zorgplicht. Deze kon meebrengen dat de vermogensbeheerder de cliënt, ondanks diens eigenzinnigheid en betrokkenheid bij de onderneming waarin is belegd, uitdrukkelijk en in niet voor misverstand vatbare bewoordingen diende te waarschuwen voor de door deze m.b.t. de samenstelling van zijn portefeuille genomen risico’s. Ter beantwoording van de vragen of de waarschuwingsplicht in een concreet geval bestaat, en hoever zij strekt, dienen alle relevante omstandigheden van het geval te worden meegewogen. De in HR 31 maart 2006, LJN AU6092, Nefalit/Keramus, geformuleerde rechtsregel dient - gelet op het daaraan verbonden bezwaar dat iemand mogelijk aansprakelijk wordt gehouden voor een schade die hij niet, of niet in de door de rechter aangenomen mate, heeft veroorzaakt - met terughoudendheid te worden toegepast. De rechter die deze regel toepast dient, om deze reden, bovendien in zijn motivering te verantwoorden dat de strekking van de geschonden norm en de aard van de normschending - waaronder begrepen de aard van de door de benadeelde geleden schade - deze toepassing in het concrete geval rechtvaardigen. Deze rechtsregel is niet alleen van toepassing op een situatie als zich voordeed in Nefalit/Keramus. Voor toepassing kan met name aanleiding zijn als de aansprakelijkheid van de aangesprokene vaststaat, en een niet zeer kleine kans bestaat dat het c.s.q.n.-verband bestaat tussen geschonden norm en geleden schade en de strekking van de geschonden norm en de aard van de normschending toepassing rechtvaardigen.",
			"authorities": 0,
			"hubs": 0.028849603305574067,
			"community": "0",
			"ecli": "ECLI:NL:HR:2010:BO1799",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2010-12-24",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 8,
			"x": 0.14035861096535096,
			"y": 0.7221935424303828,
			"title": "ECLI:NL:HR:2010:BO1799 Hoge Raad , 24-12-2010 / 09/01275",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2010
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236",
			"out_degree_centrality": 0.01935483870967742,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 5,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"6:174 bw"
			],
			"in_degree": 0,
			"abstract": "Bezittersaansprakelijkheid voor verschuiving kade (een veendijk). (Bouw)werk in de zin van art. 6:174 BW vereist menselijk ingrijpen dat heeft bijgedragen aan de (duurzame) bestemming of functie van dat werk. Oordeel hof dat de dijk een opstal is nu het dijklichaam is ontstaan door uitgraving en drooglegging, is gevormd naar de inzichten in waterkeringen, in stand is gehouden overeenkomstig daarvoor ontwikkelde richtlijnen en voorzien is van een in de grond aangebrachte beschoeiing, is juist. Bij het antwoord op de vraag of de opstal voldoet aan de eisen die men daaraan in de gegeven omstandigheden mag stellen, komt het aan op de - naar objectieve maatstaven te beantwoorden - vraag of de opstal, gelet op het te verwachten gebruik of de bestemming daarvan, met het oog op voorkoming van gevaar voor personen en zaken deugdelijk is, waarbij ook van belang is hoe groot de kans op verwezenlijking van het gevaar is en welke onderhouds- en veiligheidsmaatregelen mogelijk en redelijkerwijs te vergen zijn. Anders dan het hof heeft geoordeeld, komt bij de beoordeling of de dijk gebrekkig was betekenis toe aan de toenmalige stand van wetenschap en techniek en de financiële kaders waarbinnen het overheidslichaam zijn beleidsdoelstellingen tracht te realiseren, alsmede aan de gestelde specifieke en uitzonderlijke omstandigheden waaronder de dijkverschuiving zich heeft voorgedaan. Of bezitter bij bekendheid met het gevaar toerekenbaar onrechtmatig heeft gehandeld, hangt af van alle relevante omstandigheden van het geval en daarbij kan ook betekenis toekomen aan omstandigheden die de bezitter in het kader van zijn beroep op de afwezigheid van een gebrekkige toestand heeft aangevoerd. Oordeel hof dat beroep op tenzij-clausule moet worden afgewezen, onjuist noch onbegrijpelijk.",
			"authorities": 0,
			"hubs": 5.421299387173451e-57,
			"community": "7",
			"ecli": "ECLI:NL:HR:2010:BN6236",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2010-12-17",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.01935483870967742,
			"count_version": 10,
			"x": 0.33815463714618754,
			"y": 0.7375954463533632,
			"title": "ECLI:NL:HR:2010:BN6236 Hoge Raad , 17-12-2010 / 09/03735",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 3,
			"degree": 3,
			"year": 2010
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Wet op de rechterlijke organisatie 81"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Arbeidsongeval in de zin van art. 7:658 BW; arbeidsongeschiktheid als gevolg van drinken verontreinigd drinkwater uit onverzegelde fles op platform in tropen en door onhygiënische situatie aldaar. Verweer werkgever dat hij ten aanzien van de te treffen voorzorgsmaatregelen aan zijn verplichtingen heeft voldaan, in het licht van gemotiveerde stellingen werkgever, onvoldoende betwist. Geen miskenning van ex art. 7:658 lid 2 BW op werkgever rustende bewijslast (vgl. HR 25 mei 2007, NJ 2008/463). Enkele omstandigheid dat een algemeen bekend risico zich verwezenlijkt, schept nog geen verplichting tot treffen maatregelen (vgl. HR 8 februari 2008, NJ 2008/93). Stelplicht.",
			"authorities": 0,
			"hubs": 0.00030255519676348423,
			"community": "4",
			"ecli": "ECLI:NL:HR:2010:BN9977",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2010-11-26",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.014746543778801843,
			"count_version": 9,
			"x": 0.7105313024185851,
			"y": 0.4783137714548331,
			"title": "ECLI:NL:HR:2010:BN9977 Hoge Raad , 26-11-2010 / 09/04674",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2010
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BO3935",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.6236909940434693e-38,
			"hubs": 0,
			"community": "20",
			"ecli": "ECLI:NL:XX:2010:BO3935",
			"pagerank": 0.004491219658822496,
			"betweenness_centrality": 0,
			"date": "2010-10-21",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.05,
			"closeness_centrality": 0,
			"count_version": 5,
			"x": 0.9369905681073917,
			"y": 0.9542872265781124,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 2010
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"6:100 bw"
			],
			"in_degree": 0,
			"abstract": "Verbintenissenrecht/verzekeringsrecht. Verrekening van voordeel ex art. 6:100 BW. Aan werknemer overkomen ongeval als gevolg waarvan hij blijvend invalide is. Of aan werknemer uit hoofde van een ten behoeve van hem door de werkgever afgesloten ongevallenverzekering uitbetaald bedrag als voordeel in de zin van art. 6:100 BW in redelijkheid in mindering moet worden gebracht op het door de aansprakelijkheidsverzekeraar van de werkgever aan werknemer uit te keren bedrag hangt af van diverse omstandigheden. Aan de rechter is een ruime vrijheid gelaten om te beoordelen of verrekening van voordeel in een concreet geval redelijk is. Gezichtspunten voor verrekening in geval van letselschade en voordeel dat bestaat uit een verzekeringsuitkering.",
			"authorities": 0,
			"hubs": 8.75865925256645e-72,
			"community": "19",
			"ecli": "ECLI:NL:HR:2010:BM7808",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2010-10-01",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 7,
			"x": 0.9337692396902756,
			"y": 0.5520852222824065,
			"title": "ECLI:NL:HR:2010:BM7808 Hoge Raad , 01-10-2010 / 09/00418",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2010
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"3:310 bw",
				"7:658 bw"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Verjaring van op grond van art. 7:658 BW tegen werkgever ingestelde vordering tot vergoeding schade als gevolg van RSI-klachten. Om de verjaringstermijn te doen aanvangen is geen bekendheid van benadeelde met alle schadecomponenten vereist. Voldoende is dat benadeelde bekend is met schade die hij lijdt of heeft geleden als gevolg van foutief handelen. Verjaring die op de voet van art. 3:310 BW begint te lopen, geldt mede voor de vordering tot vergoeding van schade waarvan de benadeelde kon verwachten dat hij die als gevolg van datzelfde tekortschietend handelen zou kunnen gaan lijden. Maatstaf verjaring: HR 9 oktober 2009, LJN BJ 4850.",
			"authorities": 0,
			"hubs": 1.3401624883961085e-29,
			"community": "6",
			"ecli": "ECLI:NL:HR:2010:BM7041",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2010-09-10",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 9,
			"x": 0.09061799277723226,
			"y": 0.7228758966015412,
			"title": "ECLI:NL:HR:2010:BM7041 Hoge Raad , 10-09-2010 / 08/04220",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2010
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN3831",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 4,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "Inkomstenbelasting/premie volksverzekeringen; artikel 3.145, lid 1, Wet IB: Hof verdeelt bewijslast bijtelling auto van de zaak verkeerd; beroep op interne compensatie in hoger beroep mogelijk zonder incidenteel hoger beroep in te stellen; verwijzing.",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "27",
			"ecli": "ECLI:NL:HR:2010:BN3831",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "2010-08-13",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.043478260869565216,
			"closeness_centrality": 0,
			"count_version": 6,
			"x": 0.46825614111628633,
			"y": 0.8875582102835645,
			"title": "ECLI:NL:HR:2010:BN3831 Hoge Raad , 13-08-2010 / 08/03782",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#bestuursrecht_belastingrecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2010
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
			"out_degree_centrality": 0,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"6:101 bw"
			],
			"in_degree": 3,
			"abstract": "Luchtvaartwet (LVW), schadeloosstelling ex art. 50 (oud), waardevermeerdering ex art. 55 (oud). Geschil over schade door bouwverbod voor terrein in nabijheid van luchthaven Schiphol (zie ook HR 6 februari 2009, LJN BG5056). Ontvankelijkheid in cassatie (art. 54 lid 4 en 5 LVW jo. 53 Ow), herstel vormverzuim niet-betekening afgelegde verklaring. Economisch eigenaar moet voor de toepassing van art. 50 en 55 LVW worden aangemerkt als eigenaar. Recht om waardevermeerdering te vorderen ex art. 55 LVW gaat niet teniet doordat deze bepaling in 2003 buiten werking is gesteld voor luchthaven Schiphol, nu het bouwverbod voor die tijd is opgelegd. Het systeem van de LVW laat toepassing van de eigenschuld-regeling van art. 6:101 BW onverlet. Bij de vaststelling van de schadeloosstelling ex art. 50 LVW dient ook rekening te worden gehouden met de (in art. 55 LVW bedoelde) gevolgen van de opheffing van het bouwverbod. In procedure ex art. 50 LVW mag rechter ook wat betreft zekerheidstelling rekening houden met het bepaalde in art. 55 LVW. Leer van de bindende eindbeslissing geldt niet in een procedure op de voet van art. 50 LVW. Regeling verandering/vermeerdering eis in art. 130 Rv. is niet van toepassing in procedure ex art. 50 LVW.",
			"authorities": 0.07610823628465141,
			"hubs": 0,
			"community": "0",
			"ecli": "ECLI:NL:HR:2010:BK4476",
			"pagerank": 0.006666384047121367,
			"betweenness_centrality": 0,
			"date": "2010-02-19",
			"in_degree_centrality": 0.01935483870967742,
			"rel_in_degree": 0.125,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.6351150765315371,
			"y": 0.31119633468821406,
			"title": "ECLI:NL:HR:2010:BK4476 Hoge Raad , 19-02-2010 / 08/01550 en 08/01502",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 3,
			"year": 2010
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BL0510",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.6236909940434693e-38,
			"hubs": 0,
			"community": "20",
			"ecli": "ECLI:NL:XX:2010:BL0510",
			"pagerank": 0.004491219658822496,
			"betweenness_centrality": 0,
			"date": "2010-01-19",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.04,
			"closeness_centrality": 0,
			"count_version": 5,
			"x": 0.5891665187423467,
			"y": 0.5132926538949325,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 2010
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"83c zfw",
				"Ziekenfondswet 83c"
			],
			"in_degree": 0,
			"abstract": "Sociale zekerheidsrecht. Regresrecht ex art. 83c Zfw? Zware verwonding bij arbeidsongeval. Aansprakelijkheid werkgever ex art. 7:658 BW brengt nog niet met zich dat ziekenfonds op hem ex art. 83c Zfw regres kan nemen. Het arbeidsongeval moet in overwegende mate het gevolg zijn van een, aan de leiding van de onderneming te wijten, falende organisatie van de bewuste, risicovolle, werkzaamheden binnen de onderneming van de werkgever, welke van dien aard is dat deze als opzet of bewuste roekeloosheid van de werkgever valt aan te merken. Om handelen of nalaten van een werknemer van een rechtspersoon als opzet of bewuste roekeloosheid van de werkgever te kunnen kwalificeren, zal in het algemeen bepalend zijn of de positie van deze werknemer binnen de kring van de onderneming in het maatschappelijk verkeer met die van de desbetreffende bestuurder op één lijn kan worden gesteld.",
			"authorities": 0,
			"hubs": 8.75865925256645e-72,
			"community": "21",
			"ecli": "ECLI:NL:HR:2009:BJ7832",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2009-11-27",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 7,
			"x": 0.10216875574675943,
			"y": 0.17264656102106635,
			"title": "ECLI:NL:HR:2009:BJ7832 Hoge Raad , 27-11-2009 / 07/13470",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2009
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI9632",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"6 evrm",
				"Verdrag inzake de verlening van Europese octrooien (Europees Octrooiverdrag), München, 05-10-1973"
			],
			"in_degree": 0,
			"abstract": "Internationaal privaatrecht. Immuniteit van jurisdictie van internationale organisatie (Europese Octrooi Organisatie) in arbeidsgeschil voor Nederlandse rechter. Geschillen die onmiddellijk verband houden met de vervulling van de aan de internationale organisatie opgedragen taken (maatstaf). Vraag of interne rechtsgang binnen de internationale organisatie voldoet aan art. 6 EVRM (recht op openbare hoorzitting).",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "1",
			"ecli": "ECLI:NL:HR:2009:BI9632",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2009-10-23",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 6,
			"x": 0.1184961131647716,
			"y": 0.9984309024243107,
			"title": "ECLI:NL:HR:2009:BI9632 Hoge Raad , 23-10-2009 / 08/00118",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2009
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ4850",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"3:310 bw"
			],
			"in_degree": 1,
			"abstract": "Verbintenissenrecht. Borgstelling. Daadwerkelijk bekend met schade. Verjaringstermijn van 5 jaar als bedoeld in art. 3:310 lid 1 BW. Stuiting. Maatstaf (vgl. HR 24 januari 2003, NJ 2003, 300 en HR 20 februari 2004, NJ 2006, 113). Bekendheid met kans op schade niet voldoende.",
			"authorities": 7.206213554442336e-30,
			"hubs": 0,
			"community": "6",
			"ecli": "ECLI:NL:HR:2009:BJ4850",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "2009-10-09",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.03571428571428571,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.6331523163825813,
			"y": 0.7538687109079258,
			"title": "ECLI:NL:HR:2009:BJ4850 Hoge Raad , 09-10-2009 / 07/13351",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2009
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI6323",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "Procesrecht. Arbeidsrecht. Kennelijk onredelijk ontslag. Oordeel niet te verenigen met oordeel van hof in 7:658-zaak. Innerlijke tegenstrijdigheid arrest.",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "15",
			"ecli": "ECLI:NL:HR:2009:BI6323",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2009-09-11",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 7,
			"x": 0.10636939088209563,
			"y": 0.8363765186546518,
			"title": "ECLI:NL:HR:2009:BI6323 Hoge Raad , 11-09-2009 / 07/12246",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2009
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI4209",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:646 bw"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Seksuele intimidatie?, maatstaf, gezichtspunten; aansluiting bij art. 7:646 lid 8 BW. Procesrecht. Overlegging van processtukken uit andere procedure.",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "5",
			"ecli": "ECLI:NL:HR:2009:BI4209",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2009-07-10",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 6,
			"x": 0.13557845805201973,
			"y": 0.9902489314533248,
			"title": "ECLI:NL:HR:2009:BI4209 Hoge Raad , 10-07-2009 / 07/13308",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2009
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI1508",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Wet op de rechterlijke organisatie 81"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid op voet van art. 7:658 BW voor psychische schade;  vervolg op HR 11 maart 2005, nr. C03/289, RvdW 2005, 37; geding na verwijzing (81 RO).",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "12",
			"ecli": "ECLI:NL:HR:2009:BI1508",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2009-06-05",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 4,
			"x": 0.16715299140474782,
			"y": 0.6359719926740764,
			"title": "ECLI:NL:HR:2009:BI1508 Hoge Raad , 05-06-2009 / C07/164HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2009
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BH1996",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:611 bw",
				"7:658 bw"
			],
			"in_degree": 1,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid voor letselschade van werknemer na ongeval tijdens bedrijfsuitje (rollerskateles) wegens schending van een op eisen van goed werkgeverschap ex art. 7:611 BW gebaseerde zorg- en preventieplicht; geen toepasselijkheid van art. 7:658 BW.",
			"authorities": 0.0009448238034196425,
			"hubs": 0,
			"community": "2",
			"ecli": "ECLI:NL:HR:2009:BH1996",
			"pagerank": 0.00504592452096377,
			"betweenness_centrality": 0,
			"date": "2009-04-17",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.03125,
			"closeness_centrality": 0,
			"count_version": 7,
			"x": 0.2115476069804738,
			"y": 0.7275099697063458,
			"title": "ECLI:NL:HR:2009:BH1996 Hoge Raad , 17-04-2009 / 08/00635",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2009
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF0003",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Wet op de rechterlijke organisatie 81"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; aan werknemer in uitoefening van werkzaamheden overkomen ongeval bij uitstappen van vrachtwagen na tanken op ernstig vervuild benzinestation; zorgplicht van werkgever ex art. 7:658 BW; gevaarzetting; aanvullende verzekeringsplicht op grond van art. 7:611, behoorlijke verzekering?",
			"authorities": 0,
			"hubs": 0.0002787024929694404,
			"community": "2",
			"ecli": "ECLI:NL:HR:2009:BF0003",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2009-02-20",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.029325513196480937,
			"count_version": 9,
			"x": 0.22694557822340955,
			"y": 0.12924588127570769,
			"title": "ECLI:NL:HR:2009:BF0003 Hoge Raad , 20-02-2009 / 07/11410",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2009
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.025806451612903226,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; beroepsziekte (rugklachten na rugbelastend werk)?; causaal verband, maatstaf; stelplicht en bewijslastverdeling, omkeringsregel?; passeren van een bewijsaanbod; beleidsvrijheid (appel)rechter  tot inwinnen van gevraagd deskundigenbericht.",
			"authorities": 0.09273823602123499,
			"hubs": 0.10280229395773727,
			"community": "0",
			"ecli": "ECLI:NL:HR:2009:BF8875",
			"pagerank": 0.005035010755897214,
			"betweenness_centrality": 0,
			"date": "2009-01-09",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.058823529411764705,
			"closeness_centrality": 0.027489481065918652,
			"count_version": 9,
			"x": 0.4230782350715523,
			"y": 0.8411360721221801,
			"title": "ECLI:NL:HR:2009:BF8875 Hoge Raad , 09-01-2009 / 07/11534",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 4,
			"year": 2009
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.025806451612903226,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:611 bw"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; aan werknemer in uitoefening van werkzaamheden overkomen verkeersongeval tijdens gemotoriseerd vervoer tussen vestigingen van werkgever, “woon-werkverkeer”?; zorgplicht van werkgever ex art. 7:658 en aanvullende verzekeringsplicht op grond van art. 7:611 BW; behoorlijke verzekering van aan verkeer op de openbare weg deelnemende werknemers (ongevalleninzittendenverzekering).",
			"authorities": 0,
			"hubs": 0.008613686829314389,
			"community": "2",
			"ecli": "ECLI:NL:HR:2008:BD7480",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2008-12-19",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.041634408602150536,
			"count_version": 9,
			"x": 0.7534678384259095,
			"y": 0.5057249522769127,
			"title": "ECLI:NL:HR:2008:BD7480 Hoge Raad , 19-12-2008 / 07/10672",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 4,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:611 bw"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; aan werknemer in uitoefening van werkzaamheden overkomen verkeersongeval tijdens vervoer met auto-ambulance op weg naar bedrijf werkgever, “woon-werkverkeer”?; zorgplicht van werkgever ex art. 7:658 en aanvullende verzekeringsplicht op grond van art. 7:611 BW; behoorlijke verzekering van aan verkeer op de openbare weg deelnemende werknemers.",
			"authorities": 0,
			"hubs": 0.002717666182918857,
			"community": "2",
			"ecli": "ECLI:NL:HR:2008:BG7775",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2008-12-19",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.04003308519437552,
			"count_version": 9,
			"x": 0.7403094765068521,
			"y": 0.6722851257052685,
			"title": "ECLI:NL:HR:2008:BG7775 Hoge Raad , 19-12-2008 / 07/10859",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
			"out_degree_centrality": 0.03870967741935484,
			"degree_centrality": 0.05161290322580645,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:611 bw",
				"7:658 bw"
			],
			"in_degree": 2,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; bij eenzijdig verkeersongeval geleden letselschade door fietsende werknemer (thuiszorger) tijdens uitoefening van haar werkzaamheden; zorgplicht van werkgever ex art. 7:658 BW en aanvullende verzekeringsplicht op grond van art. 7:611 BW; behoorlijke verzekering van aan verkeer op de openbare weg deelnemende werknemers.",
			"authorities": 0.0009665312056490926,
			"hubs": 0.008406351433425547,
			"community": "2",
			"ecli": "ECLI:NL:HR:2008:BD3129",
			"pagerank": 0.00803131867234144,
			"betweenness_centrality": 0.0009216589861751152,
			"date": "2008-12-12",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.05405405405405406,
			"closeness_centrality": 0.043548387096774194,
			"count_version": 9,
			"x": 0.4346445326456442,
			"y": 0.7066996798577558,
			"title": "ECLI:NL:HR:2008:BD3129 Hoge Raad , 12-12-2008 / C07/121HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 6,
			"degree": 8,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BE7201",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 24"
			],
			"in_degree": 1,
			"abstract": "Procesrecht. Grenzen rechtsstrijd van partijen; afspraak ter comparitie dat onder overlegging van alle gedingstukken uit de andere procedure deze geacht kunnen worden te zijn herhaald en ingelast in de onderhavige procedure; niet voldoende om wat in die stukken aan stellingen en feiten is te vinden als aangevoerd in het onderhavige geding te beschouwen; de partij die zulke stellingen en feiten wil inroepen, dient dit op een zodanige wijze te doen dat dat voor de rechter en de wederpartij duidelijk is.",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "5",
			"ecli": "ECLI:NL:HR:2008:BE7201",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "2008-10-17",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.02631578947368421,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.9946255903315541,
			"y": 0.11271022487214866,
			"title": "ECLI:NL:HR:2008:BE7201 Hoge Raad , 17-10-2008 / C07/037HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 4,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:661 bw"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Verhaal door werkgever op werknemers van verkeersboetes die aan de werkgever als kentekenhouder zijn opgelegd voor door werknemers tijdens de uitoefening van hun werkzaamheden begane verkeersovertredingen; uitleg art. 7:661 BW.",
			"authorities": 0,
			"hubs": 8.75865925256645e-72,
			"community": "16",
			"ecli": "ECLI:NL:HR:2008:BC8791",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2008-06-13",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 11,
			"x": 0.5299505229820243,
			"y": 0.28940529201564213,
			"title": "ECLI:NL:HR:2008:BC8791 Hoge Raad , 13-06-2008 / C06/232HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9344",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 1,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid ex art. 7:658 BW voor uitglijden werknemer over opstapje tussen als kantoorruimte gebruikte portacabins; onveilige werksituatie, causaal verband.",
			"authorities": 0.002130391829413503,
			"hubs": 0,
			"community": "2",
			"ecli": "ECLI:NL:HR:2008:BC9344",
			"pagerank": 0.004976441117049863,
			"betweenness_centrality": 0,
			"date": "2008-06-06",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.025,
			"closeness_centrality": 0,
			"count_version": 8,
			"x": 0.5898222601501113,
			"y": 0.07325648439471322,
			"title": "ECLI:NL:HR:2008:BC9344 Hoge Raad , 06-06-2008 / C07/088HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC7683",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Wet op de rechterlijke organisatie 81"
			],
			"in_degree": 1,
			"abstract": "Arbeidrecht. Aansprakelijkheid werkgever ex art. 7:658 lid 2 BW; gezondheidsschade als gevolg van blootstelling aan organische oplosmiddelen; geen bewijs causaal verband met  uitoefening van de werkzaamheden (81 RO).",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "15",
			"ecli": "ECLI:NL:HR:2008:BC7683",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "2008-05-16",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.024390243902439025,
			"closeness_centrality": 0,
			"count_version": 5,
			"x": 0.10767504260378835,
			"y": 0.565130900141761,
			"title": "ECLI:NL:HR:2008:BC7683 Hoge Raad , 16-05-2008 / C06/343HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9225",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 1,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid ex art. 7:658 BW voor uitglijden werknemer op natte vloer; terbeschikkingstelling veiligheidsschoenen niet afdoende wegens mogelijkheid van neerleggen rubber matten.",
			"authorities": 0.000895900616080289,
			"hubs": 0,
			"community": "2",
			"ecli": "ECLI:NL:HR:2008:BC9225",
			"pagerank": 0.004768572089893133,
			"betweenness_centrality": 0,
			"date": "2008-04-11",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.023809523809523808,
			"closeness_centrality": 0,
			"count_version": 9,
			"x": 0.6325909715326636,
			"y": 0.42456069116897965,
			"title": "ECLI:NL:HR:2008:BC9225 Hoge Raad , 11-04-2008 / C06/293HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC6699",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 4,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:629 bw"
			],
			"in_degree": 0,
			"abstract": "Arbeidsrecht. Contractuele beperking van aanvulling op wettelijke minimumuitkering bij  arbeidsongeschiktheid, in verband met buiten de werksfeer liggende gedragingen of activiteiten van de werknemer, zonder dat sprake is van opzet werknemer is niet in strijd met art. 7:629 BW; uitleg CAO.",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "28",
			"ecli": "ECLI:NL:HR:2008:BC6699",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2008-03-14",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 10,
			"x": 0.3988749210945245,
			"y": 0.3547479198296659,
			"title": "ECLI:NL:HR:2008:BC6699 Hoge Raad , 14-03-2008 / C06/278HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"6:171 bw",
				"7:658 bw"
			],
			"in_degree": 1,
			"abstract": "Arbeidsrecht. Afgewezen vordering werknemer tegen werkgever tot vergoeding van letselschade na ongeval met dichtgewaaide laaddeur van vrachtauto van derde; werkgeversaansprakelijkheid ex art. 7:658 BW, maatstaf; aansprakelijkheid voor niet-ondergeschikten ex art. 6:171 BW (81 RO).",
			"authorities": 0.00007667549632119902,
			"hubs": 0.00003232123175810883,
			"community": "4",
			"ecli": "ECLI:NL:HR:2008:BB7423",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0.00008378718056137411,
			"date": "2008-02-08",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.022727272727272728,
			"closeness_centrality": 0.008602150537634409,
			"count_version": 8,
			"x": 0.31889041721052647,
			"y": 0.04827544547748752,
			"title": "ECLI:NL:HR:2008:BB7423 Hoge Raad , 08-02-2008 / C06/202HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 2,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:611 bw"
			],
			"in_degree": 4,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid voor de door werknemer bij een verkeersongeval met eigen auto geleden letselschade in de uitoefening van zijn werkzaamheden; zorgplicht werkgever ex art. 7:658 en op grond van goed werkgeverschap in art. 7:611 BW; behoorlijke verzekering van aan gemotoriseerd verkeer deelnemende werknemer; bewuste roekeloosheid van werknemer, maatstaf.",
			"authorities": 0.004712389086193691,
			"hubs": 0.015552022386814343,
			"community": "2",
			"ecli": "ECLI:NL:HR:2008:BB6175",
			"pagerank": 0.008422886205360297,
			"betweenness_centrality": 0.0019689987431922916,
			"date": "2008-02-01",
			"in_degree_centrality": 0.025806451612903226,
			"rel_in_degree": 0.08888888888888889,
			"closeness_centrality": 0.032384566729917776,
			"count_version": 9,
			"x": 0.22605619341174976,
			"y": 0.1162044363688457,
			"title": "ECLI:NL:HR:2008:BB6175 Hoge Raad , 01-02-2008 / C06/044HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 5,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.05161290322580645,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:611 bw"
			],
			"in_degree": 4,
			"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid voor de door werknemer als taxichauffeur (afroepkracht) in de uitoefening van zijn werkzaamheden bij een verkeersongeval geleden letselschade; zorgplicht werkgever ex art. 7:658 en op grond van goed werkgeverschap als bedoeld in art. 7:611 BW; uitwerking van HR 12 januari 2001, nr. C99/125, NJ 2001, 253 en HR 9 augustus 2002, nr. C00/234, NJ 2004, 235; behoorlijke verzekering van aan gemotoriseerd verkeer deelnemende werknemer.",
			"authorities": 0.004712389086193691,
			"hubs": 0.023321465598686603,
			"community": "2",
			"ecli": "ECLI:NL:HR:2008:BB4767",
			"pagerank": 0.008422886205360297,
			"betweenness_centrality": 0.0026183493925429407,
			"date": "2008-02-01",
			"in_degree_centrality": 0.025806451612903226,
			"rel_in_degree": 0.08695652173913043,
			"closeness_centrality": 0.04608294930875576,
			"count_version": 10,
			"x": 0.11382893612354317,
			"y": 0.000503944784689736,
			"title": "ECLI:NL:HR:2008:BB4767 Hoge Raad , 01-02-2008 / C06/211HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 8,
			"year": 2008
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB6178",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 1,
			"abstract": "Werkgeversaansprakelijkheid. Geschil over schadevergoeding na verkeersongeval werknemer; zorgplicht werkgever; vervoer op één lijn te stellen met vervoer krachtens de verplichtingen uit arbeidsovereenkomst?; ‘in de uitoefening van de werkzaamheden’ in zin van art. 7:658 lid 2 BW, ruime wetsuitleg.",
			"authorities": 0.002130391829413503,
			"hubs": 0,
			"community": "2",
			"ecli": "ECLI:NL:HR:2007:BB6178",
			"pagerank": 0.004976441117049863,
			"betweenness_centrality": 0,
			"date": "2007-11-30",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.02127659574468085,
			"closeness_centrality": 0,
			"count_version": 8,
			"x": 0.7291661577310622,
			"y": 0.5658758019989,
			"title": "ECLI:NL:HR:2007:BB6178 Hoge Raad , 30-11-2007 / C06/171HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB7191",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw",
				"Wet op de rechterlijke organisatie 81"
			],
			"in_degree": 0,
			"abstract": "Internationaal privaatrecht; vervolg op HR 12 november 2004, nr. C03/149, NJ 2005, 552. Arbeidsongeval tijdens transport van boortoren; inlenersaansprakelijkheid; toepasselijkheid art. 7:658 lid 4 BW, overgangsrecht; kan de inlener als materiële werkgever aansprakelijk worden gesteld voor de fouten van derden bij wie werknemer was tewerkgesteld? (81 RO).",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "14",
			"ecli": "ECLI:NL:HR:2007:BB7191",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2007-11-23",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 2,
			"x": 0.002407551909779926,
			"y": 0.9335688789160488,
			"title": "ECLI:NL:HR:2007:BB7191 Hoge Raad , 23-11-2007 / C06/186HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9173",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"12 sv"
			],
			"in_degree": 1,
			"abstract": "Cassatie in belang der wet. Euratom. Functionele immuniteit. Het hof heeft n.a.v. een beklagprocedure ex art. 12 Sv de OvJ bevolen de vervolging van Euratom voort te zetten, betrekking hebbende op overtredingen van een of meer van de vergunningsvoorwaarden en van andere milieudelicten. Het hof heeft in zijn beschikking een te nauwe maatstaf aangelegd. Het gaat erom of de desbetreffende gedragingen onmiddellijk verband houden met de vervulling van de aan Euratom opgedragen taken en niet, zoals het hof klaarblijkelijk als maatstaf heeft genomen, of Euratom haar taken ook kan uitoefenen zonder strafbare feiten te begaan. HR vernietigt in het belang der wet de bestreden beschikking.",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "1",
			"ecli": "ECLI:NL:HR:2007:BA9173",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "2007-11-13",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.02040816326530612,
			"closeness_centrality": 0,
			"count_version": 6,
			"x": 0.6439732641208743,
			"y": 0.9866235689322017,
			"title": "ECLI:NL:HR:2007:BA9173 Hoge Raad , 13-11-2007 / 01984/07 CW",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#strafrecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
			"out_degree_centrality": 0,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 3,
			"abstract": "Aansprakelijkheidsrecht. Afgewezen schadevordering van automobilist na aanrijding met tractor; causaal verband tussen ongeval en verlies arbeidsvermogen?; volgen door rechter van (voorlopig) deskundigenbericht, bezwaren partijen, stelplicht; smartengeld, schadebegroting, rechtsstrijd van partijen, taak appelrechter.",
			"authorities": 0.07610823628465141,
			"hubs": 0,
			"community": "0",
			"ecli": "ECLI:NL:HR:2007:BB5172",
			"pagerank": 0.006666384047121367,
			"betweenness_centrality": 0,
			"date": "2007-10-19",
			"in_degree_centrality": 0.01935483870967742,
			"rel_in_degree": 0.06,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.3070353260403881,
			"y": 0.04238892303252473,
			"title": "ECLI:NL:HR:2007:BB5172 Hoge Raad , 19-10-2007 / C06/086HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 3,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9705",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:941 bw"
			],
			"in_degree": 0,
			"abstract": "Verzekeringsrecht. Verwezenlijking van verzekerd risico, meldingsplicht verzekerde, verval recht op uitkering; art. 7:941 lid 4 BW is codificatie van naar oud recht gegroeide rechtsovertuiging; omvang stelplicht verzekeraar en verzekerde.",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "22",
			"ecli": "ECLI:NL:HR:2007:BA9705",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2007-10-05",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 5,
			"x": 0.6036260772083,
			"y": 0.04801440815843894,
			"title": "ECLI:NL:HR:2007:BA9705 Hoge Raad , 05-10-2007 / C06/033HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA7217",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "Verzekeringsrecht; vervolg op HR 4 oktober 2002, nr. C01/326, NJ 2002, 557. Vordering van uitzendbureau tegen verzekeraar tot verlenen dekking voor schadevergoeding aan zijn werknemer uit werkgeversaansprakelijkheid; uitleg van (uitsluitingsclausule in) polisvoorwaarden, maatstaf; ‘spiegelbeelddekking’ van AVB- en WAM-polissen; grenzen rechtsstrijd in hoger beroep.",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "4",
			"ecli": "ECLI:NL:HR:2007:BA7217",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2007-07-13",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.00967741935483871,
			"count_version": 6,
			"x": 0.7613404156280678,
			"y": 0.05202984237778607,
			"title": "ECLI:NL:HR:2007:BA7217 Hoge Raad , 13-07-2007 / C06/089HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "Werkgeversaansprakelijkheid. Schadevordering van werkneemster na val van podium ondanks waarschuwing en aanwezigheid van trapje; omvang van door werkgever jegens een verstandelijk gehandicapte werknemer te betrachten zorgplicht, extra inspanning tot geven van aanwijzingen, instructies of waarschuwingen?; stelplicht- en bewijslast; bevrijdend verweer van de werkgever, eisen te stellen aan motivering van de betwisting door de werknemer.",
			"authorities": 0.0009725761124014882,
			"hubs": 0,
			"community": "4",
			"ecli": "ECLI:NL:HR:2007:BA3017",
			"pagerank": 0.006399945381117286,
			"betweenness_centrality": 0,
			"date": "2007-05-25",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.03773584905660377,
			"closeness_centrality": 0,
			"count_version": 8,
			"x": 0.7241684212922317,
			"y": 0.04821037988667709,
			"title": "ECLI:NL:HR:2007:BA3017 Hoge Raad , 25-05-2007 / C06/128HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Arbeidsomstandighedenbesluit 5.2"
			],
			"in_degree": 0,
			"abstract": "Werkgeversaansprakelijkheid. Schadevordering werknemer na ongeval bij het optillen van zware oven. Omvang van door werkgever jegens zijn werknemer te betrachten zorgplicht; regels van algemene bekendheid; stelplicht, aan gemotiveerde betwisting van de stellingen van werknemer te stellen eisen; uitwerking van HR 17 november 2000, nr. C98/273, NJ 2001, 596.",
			"authorities": 0,
			"hubs": 0.0757936806270237,
			"community": "0",
			"ecli": "ECLI:NL:HR:2007:AZ6717",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2007-04-27",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.03303225806451613,
			"count_version": 8,
			"x": 0.9095503461193879,
			"y": 0.6276912518123491,
			"title": "ECLI:NL:HR:2007:AZ6717 Hoge Raad , 27-04-2007 / C05/192HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ7863",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "Aanrijding voetganger door auto op donkere weg. Eis van bewustheid van het gevaar bij het slachtoffer voor aan opzet grenzende roekeloosheid als bedoeld in de 50%-regel. Stelplicht en bewijslast omvat ook de bewustheid van het gevaar bij het slachtoffer. Aan het bewijs van deze bewustheid door aansprakelijk gestelde partij te stellen eisen.",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "26",
			"ecli": "ECLI:NL:HR:2007:AZ7863",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2007-03-30",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 7,
			"x": 0.5248097379590805,
			"y": 0.4743854845592703,
			"title": "ECLI:NL:HR:2007:AZ7863 Hoge Raad , 30-03-2007 / C05/226HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6526",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "Arbeidsongeval. Werkgeversaansprakelijkheid voor letselschade werknemer als gevolg van zijn val van een dak bij sloopwerkzaamheden (verwijdering van asbestplaten); zorgplicht werkgever, uitdrukkelijk opdracht door werkgever tot treffen en naleven van valbeschermingsmaatregelen; waardering getuigenbewijs waaronder verklaring van een jeugdige getuige.",
			"authorities": 0,
			"hubs": 0.000006721648365199486,
			"community": "18",
			"ecli": "ECLI:NL:HR:2007:AZ6526",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2007-02-09",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 8,
			"x": 0.1490714922671713,
			"y": 0.2512371710218888,
			"title": "ECLI:NL:HR:2007:AZ6526 Hoge Raad , 09-02-2007 / C05/337HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2007
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2006:AY0534",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.6236909940434693e-38,
			"hubs": 0,
			"community": "20",
			"ecli": "ECLI:NL:XX:2006:AY0534",
			"pagerank": 0.004491219658822496,
			"betweenness_centrality": 0,
			"date": "2006-07-04",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.017543859649122806,
			"closeness_centrality": 0,
			"count_version": 2,
			"x": 0.4303455092545325,
			"y": 0.24124654923585365,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 2006
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 4,
			"abstract": "Werkgeversaansprakelijkheid. Geschil tussen een werknemer en zijn voormalige werkgever over aansprakelijkheid krachtens art. 7A:1638x (oud) BW voor een door de werknemer beweerdelijk tijdens de uitoefening van zijn werkzaamheden opgelopen aandoening aan de luchtwegen en aan het zenuwstelsel (organisch psychosyndroom); overgangsrecht NBW, onmiddellijke werking van art. 7:658 BW; oorzakelijk verband tussen blootstelling aan voor gezondheid gevaarlijke stoffen en lichamelijke klachten van de werknemer, stelplicht en bewijslastverdeling, regel als bedoeld in HR 17 november 2000, nr. C98/273, NJ 2001, 596 (Unilever/Dikmans) in casu niet toepasselijk.",
			"authorities": 0.16152901504573125,
			"hubs": 0.05622486436516606,
			"community": "0",
			"ecli": "ECLI:NL:HR:2006:AW6166",
			"pagerank": 0.007827412820573863,
			"betweenness_centrality": 0,
			"date": "2006-06-23",
			"in_degree_centrality": 0.025806451612903226,
			"rel_in_degree": 0.06896551724137931,
			"closeness_centrality": 0.024229390681003583,
			"count_version": 7,
			"x": 0.7220022474021931,
			"y": 0.483995334059821,
			"title": "ECLI:NL:HR:2006:AW6166 Hoge Raad , 23-06-2006 / C05/149HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 5,
			"year": 2006
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093",
			"out_degree_centrality": 0.01935483870967742,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 0,
			"abstract": "Geschil tussen een asbestverwerkend bedrijf dat van 1961 tot 1975 werkgever was van een asbestmenger die in 1984 aan longkanker zonder voorafgaande asbestose is overleden, en diens weduwe over aansprakelijkheid op de voet van art. 7:658 BW; was zijn longkanker ook zonder asbestexpositie ontstaan?; zorgplicht werkgever tot het treffen van de vereiste veiligheidsmaatregelen, ook bij aanzienlijke kansverhoging verwezenlijking van onbekende gevaren door nalatigheid werkgever.",
			"authorities": 0,
			"hubs": 5.509931302562919e-13,
			"community": "8",
			"ecli": "ECLI:NL:HR:2006:AU6093",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2006-03-31",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.03629032258064516,
			"count_version": 3,
			"x": 0.31505645892084755,
			"y": 0.7722596669717336,
			"title": "ECLI:NL:HR:2006:AU6093 Hoge Raad , 31-03-2006 / C04/304HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 3,
			"degree": 3,
			"year": 2006
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
			"out_degree_centrality": 0,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 3,
			"abstract": "Geschil tussen een asbestverwerkend bedrijf dat van 1964 tot 1979 werkgever was van een fabrieksarbeider die minstens 28 jaar heeft gerookt en in 2000 aan longkanker zonder voorafgaande asbestose is overleden, en zijn erfgenamen over werkgeversaansprakelijkheid op de voet van art. 7:658 BW; longkanker behalve door blootstelling aan asbeststof in de uitoefening van werkzaamheden ook veroorzaakt door langjarig rookgedrag?; zorgplicht werkgever tot het treffen van de vereiste veiligheidsmaatregelen, aanzienlijke kansverhoging verwezenlijking van nog onbekende gevaren door nalatigheid werkgever; aanvaarding door de HR van proportionele aansprakelijkheid; causaal verband normschending en geleden schade, eigen schuld; devolutieve werking van het appel, grievenstelsel.",
			"authorities": 0.10004948850059989,
			"hubs": 0,
			"community": "0",
			"ecli": "ECLI:NL:HR:2006:AU6092",
			"pagerank": 0.008297757338345521,
			"betweenness_centrality": 0,
			"date": "2006-03-31",
			"in_degree_centrality": 0.01935483870967742,
			"rel_in_degree": 0.05,
			"closeness_centrality": 0,
			"count_version": 7,
			"x": 0.8361185320565112,
			"y": 0.06107769534341445,
			"title": "ECLI:NL:HR:2006:AU6092 Hoge Raad , 31-03-2006 / C04/303HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 3,
			"year": 2006
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 1,
			"abstract": "Asbestzaak. Geschil tussen werkgever en de erven van een oud-werknemer over werkgeversaansprakelijkheid op grond van art. 7:658 BW wegens blootstelling van deze werknemer aan asbeststof gedurende zijn dienstverband in de periode 1965-1967 in de uitoefening van werkzaamheden als monteur bij verwarmingsinstallatiebedrijf; leidt onbekendheid van werkgever met het gevaar van het ontstaan van mesothelioom tot ontheffing van zijn aansprakelijkheid als de omstandigheden geen gevaar meebrachten voor asbestose?, verhoogde zorgvuldigheidsnorm, veiligheidsmaatregelen die naar de destijds bestaande kennis en inzichten van de werkgever konden worden verwacht; verlichting van bewijslast werkgever.",
			"authorities": 1.9083244303450155e-13,
			"hubs": 6.609274964965129e-13,
			"community": "8",
			"ecli": "ECLI:NL:HR:2006:AU6927",
			"pagerank": 0.00492625253648227,
			"betweenness_centrality": 0.00041893590280687055,
			"date": "2006-02-17",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.01639344262295082,
			"closeness_centrality": 0.04360400444938821,
			"count_version": 7,
			"x": 0.7455611388907855,
			"y": 0.16953010565989113,
			"title": "ECLI:NL:HR:2006:AU6927 Hoge Raad , 17-02-2006 / C04/199HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 5,
			"year": 2006
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU9717",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"6:97 bw"
			],
			"in_degree": 1,
			"abstract": "Internationaal verzekeringsgeschil n.a.v. een schikking binnen de filmindustrie; dekking polis, uitleg naar Nederlands recht van op de Londense beurs gesloten verzekering, Haviltex-maatstaf, ter beurze bestaande opvattingen; beroep op vervalbeding in een verzekeringsovereenkomst, derogerende werking van redelijkheid en billijkheid, motiveringsplicht; begroting schadeomvang op de voet van art. 6:97 BW, motiveringseisen.",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "22",
			"ecli": "ECLI:NL:HR:2006:AU9717",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "2006-02-17",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.016129032258064516,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.26065443790735154,
			"y": 0.21194816418601792,
			"title": "ECLI:NL:HR:2006:AU9717 Hoge Raad , 17-02-2006 / C04/322HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2006
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "Kort geding asbestzaak, aansprakelijkheid van leverancier van asbestcementplaten voor ziekte mesothelioom die door blootstelling in 1971 aan asbest is veroorzaakt; tekortschieten van de leverancier in plicht het publiek te waarschuwen voor de toen reeds bekende gezondheidsrisico’s die aan verwerking van asbest zijn verbonden, onrechtmatige nalatigheid?, maatstaven; bevrijdende verjaring, beroep op objectieve verjaringstermijn (30 jaren), derogerende werking van de redelijkheid en billijkheid, gezichtspunten.",
			"authorities": 0,
			"hubs": 1.6496153691232217e-13,
			"community": "8",
			"ecli": "ECLI:NL:HR:2005:AT8782",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2005-11-25",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.03831867057673509,
			"count_version": 5,
			"x": 0.4157469657347368,
			"y": 0.7929456933659428,
			"title": "ECLI:NL:HR:2005:AT8782 Hoge Raad , 25-11-2005 / C04/182HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2005
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.025806451612903226,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:658 bw"
			],
			"in_degree": 2,
			"abstract": "Arbeidsongeval met lichamelijk letsel bij de bediening van een gevaarlijke (inpak)machine ondanks de door de werkgever getroffen (veiligheids)maatregelen, werkgeversaansprakelijkheid, strekking van art. 7:658 BW, waarschuwingsplicht van werkgever, effectieve(re) maatregelen?, voorzienbaarheid van het te duchten gevaar.",
			"authorities": 0.0678640200637628,
			"hubs": 8.75865925256645e-72,
			"community": "0",
			"ecli": "ECLI:NL:HR:2005:AU3313",
			"pagerank": 0.006013834730631706,
			"betweenness_centrality": 0.00016757436112274822,
			"date": "2005-11-11",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.03125,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 8,
			"x": 0.9839033257817017,
			"y": 0.9959353092513058,
			"title": "ECLI:NL:HR:2005:AU3313 Hoge Raad , 11-11-2005 / C04/253HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 4,
			"year": 2005
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU2235",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"7:661 bw",
				"7:658 bw"
			],
			"in_degree": 0,
			"abstract": "Aansprakelijkheid werknemer voor schade aan werkgever, verkeersongeval van taxichauffeur tijdens de uitoefening van werkzaamheden, negeren verkeersbord (inrijverbod) en wegafzetting, opzet of bewuste roekeloosheid in de zin van art. 7:661 lid 1 BW, gelijke uitleg van het begrip “bewuste roekeloosheid” als in art. 7:658 lid 2 BW, ervaringsfeit, bewijslastverdeling, omkeringsregel van toepassing?",
			"authorities": 0,
			"hubs": 4.8936151077444983e-32,
			"community": "4",
			"ecli": "ECLI:NL:HR:2005:AU2235",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2005-10-14",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.008602150537634409,
			"count_version": 7,
			"x": 0.2441778866851534,
			"y": 0.13105337253819904,
			"title": "ECLI:NL:HR:2005:AU2235 Hoge Raad , 14-10-2005 / C04/200HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2005
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AR6657",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 5,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "11 maart 2005 Eerste Kamer Nr. C03/289HR JMH Hoge Raad der Nederlanden Arrest in de zaak van: ABN AMRO BANK N.V., gevestigd te Amsterdam, EISERES tot cassatie, incidenteel verweerster, advocaat: mr. E. Grabandt, t e g e n [Verweerder], wonende te [woonplaats], VERWEERDER in cassatie, incidenteel eiser, advocaten: mrs. E. van Staden ten Brink en A.H. Vermeulen. 1. Het geding in feitelijke instanties...",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "12",
			"ecli": "ECLI:NL:HR:2005:AR6657",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "2005-03-11",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.015151515151515152,
			"closeness_centrality": 0,
			"count_version": 9,
			"x": 0.958049912570156,
			"y": 0.5395924042943255,
			"title": "ECLI:NL:HR:2005:AR6657 Hoge Raad , 11-03-2005 / C03/289HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2005
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.03870967741935484,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "17 december 2004 Eerste Kamer Nr. C03/211HR RM/AT Hoge Raad der Nederlanden Arrest in de zaak van: HERTEL B.V., gevestigd te Amsterdam, EISERES tot cassatie, advocaat: mr. R.S. Meijer, t e g e n 1. [Verweerder 1], wonende te [woonplaats], 2. [Verweerder 2], wonende te [woonplaats], ten dezen handelend zowel voor zichzelf als in hun hoedanigheid van erfgenamen van [betrokkene 1], VERWEERDERS in cassatie, advocaat: mr. M.J. Schenck. 1. Het geding in feitelijke instanties...",
			"authorities": 2.860406296671996e-13,
			"hubs": 6.197545859961566e-13,
			"community": "8",
			"ecli": "ECLI:NL:HR:2004:AR3290",
			"pagerank": 0.006516857305061262,
			"betweenness_centrality": 0.0009216589861751152,
			"date": "2004-12-17",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.029850746268656716,
			"closeness_centrality": 0.03795066413662239,
			"count_version": 7,
			"x": 0.8128849901003169,
			"y": 0.7472563086318368,
			"title": "ECLI:NL:HR:2004:AR3290 Hoge Raad , 17-12-2004 / C03/211HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 6,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AP0965",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "12 november 2004 Eerste Kamer Nr. C03/149HR JMH Hoge Raad der Nederlanden Arrest in de zaak van: [Eiser], wonende te [woonplaats], EISER tot cassatie, advocaat: mr. E. Grabandt, t e g e n KCA DEUTAG NEDERLAND B.V., voorheen genaamd Deutag Nederland B.V., daarvoor genaamd Deutag Friesland Drilling B.V., gevestigd te Assen, VERWEERSTER in cassatie, advocaat: mr. R.A.A. Duk. 1. Het geding in feitelijke instanties...",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "14",
			"ecli": "ECLI:NL:HR:2004:AP0965",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "2004-11-12",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.014705882352941176,
			"closeness_centrality": 0,
			"count_version": 6,
			"x": 0.028200259700374986,
			"y": 0.15300400630636934,
			"title": "ECLI:NL:HR:2004:AP0965 Hoge Raad , 12-11-2004 / C03/149HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2004:AR5022",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.6236909940434693e-38,
			"hubs": 0,
			"community": "20",
			"ecli": "ECLI:NL:XX:2004:AR5022",
			"pagerank": 0.004491219658822496,
			"betweenness_centrality": 0,
			"date": "2004-10-05",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.014492753623188406,
			"closeness_centrality": 0,
			"count_version": 2,
			"x": 0.7594570796119381,
			"y": 0.7984704705184985,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.025806451612903226,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wet op de rechterlijke organisatie 81",
				"Wet op de rechterlijke organisatie 4"
			],
			"in_degree": 0,
			"abstract": "10 september 2004 Eerste Kamer Nr. C03/097HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: [Eiseres], wonende te [woonplaats], EISERES tot cassatie, incidenteel verweerster in cassatie, advocaat: mr. H.J.W. Alt, t e g e n 1. EURONEXT AMSTERDAM N.V., rechts-opvolgster van Amsterdam Exchanges N.V., 2. AMSTERDAM EXCHANGES N.V., beide gevestigd te Amsterdam, VERWEERSTERS in cassatie, incidenteel eiseressen tot cassatie, advocaat: mr. J.B.M.M. Wuisman.  1. Het geding in feitelijke instanties...",
			"authorities": 0,
			"hubs": 1.6941710905014642e-46,
			"community": "17",
			"ecli": "ECLI:NL:HR:2004:AO9053",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2004-09-10",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.025806451612903226,
			"count_version": 3,
			"x": 0.5235372325888104,
			"y": 0.1262658749295873,
			"title": "ECLI:NL:HR:2004:AO9053 Hoge Raad , 10-09-2004 / C03/097HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 4,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "9 juli 2004 Eerste Kamer Nr. C03/150HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: [Eiser], wonende te [woonplaats], EISER tot cassatie, advocaat: mr. E. Grabandt, t e g e n [Verweerster], gevestigd te [vestigingsplaats], VERWEERSTER in cassatie, advocaat: mr. M.H. van der Woude. 1. Het geding in feitelijke instanties...",
			"authorities": 0,
			"hubs": 0.0007267529616578021,
			"community": "18",
			"ecli": "ECLI:NL:HR:2004:AO8171",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2004-07-09",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.014516129032258065,
			"count_version": 5,
			"x": 0.7865782664149304,
			"y": 0.743968776747423,
			"title": "ECLI:NL:HR:2004:AO8171 Hoge Raad , 09-07-2004 / C03/150HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO7817",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 166",
				"Wetboek van Burgerlijke Rechtsvordering 150",
				"Wetboek van Burgerlijke Rechtsvordering 353",
				"Wetboek van Burgerlijke Rechtsvordering"
			],
			"in_degree": 1,
			"abstract": "9 juli 2004 Eerste Kamer Nr. C03/079HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: OZ EXPORT PLANTEN B.V., gevestigd te Aalsmeer, EISERES tot cassatie, advocaat: mr. E. Grabandt, t e g e n [Verweerster], gevestigd te [vestigingsplaats], VERWEERSTER in cassatie, advocaat: mr. R.F. Thunnissen. 1. Het geding in feitelijke instanties...",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "11",
			"ecli": "ECLI:NL:HR:2004:AO7817",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "2004-07-09",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.013888888888888888,
			"closeness_centrality": 0,
			"count_version": 5,
			"x": 0.7726340879956229,
			"y": 0.40826893109772855,
			"title": "ECLI:NL:HR:2004:AO7817 Hoge Raad , 09-07-2004 / C03/079HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Burgerlijk Wetboek Boek 7",
				"Burgerlijk Wetboek Boek 7 658"
			],
			"in_degree": 0,
			"abstract": "4 juni 2004 Eerste Kamer Nr. C03/034HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: 1. [Eiseres 1], wonende te [woonplaats], Spanje, 2. [Eiseres 2], wonende te [woonplaats], EISERESSEN tot cassatie, voorwaardelijk incidenteel verweersters, advocaat: mr. M.J. Schenck, t e g e n GEMEX B.V., gevestigd te 's-Gravenhage, VERWEERSTER in cassatie, voorwaardelijk incidenteel eiseres, advocaat: mr. R.S. Meijer. 1. Het geding in feitelijke instanties...",
			"authorities": 0,
			"hubs": 4.959659595841907e-13,
			"community": "8",
			"ecli": "ECLI:NL:HR:2004:AO4596",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2004-06-04",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.014746543778801843,
			"count_version": 2,
			"x": 0.2800867043553602,
			"y": 0.25417484592330286,
			"title": "ECLI:NL:HR:2004:AO4596 Hoge Raad , 04-06-2004 / C03/034HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4224",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "28 mei 2004 Eerste Kamer Nr. R03/026HR JMH/IS Hoge Raad der Nederlanden Arrest in de zaak van: [Eiseres], wonende te [woonplaats], Zwitserland, EISERES tot cassatie, advocaat: mr. M.B.C. Kloppenburg, t e g e n PRINCESS JULIANA INTERNATIONAL AIRPORT EXPLOITATIEMAATSCHAPPIJ N.V., gevestigd op Sint Maarten, Nederlandse Antillen, VERWEERSTER in cassatie, advocaat: mr. M.H. van der Woude. 1. Het geding in feitelijke instanties...",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "0",
			"ecli": "ECLI:NL:HR:2004:AO4224",
			"pagerank": 0.006394551737125777,
			"betweenness_centrality": 0,
			"date": "2004-05-28",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.013513513513513514,
			"closeness_centrality": 0,
			"count_version": 7,
			"x": 0.16083995918257832,
			"y": 0.5254003535546338,
			"title": "ECLI:NL:HR:2004:AO4224 Hoge Raad , 28-05-2004 / R03/026HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601",
			"out_degree_centrality": 0.01935483870967742,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "\n         30 januari 2004 Eerste Kamer Nr. C02/204HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: [eiseres], gevestigd te [vestigingsplaats], EISERES tot cassatie, advocaat: mr. M.H. van der Woude, t e g e n [verweerder], wonende te [woonplaats], VERWEERDER in cassatie, niet verschenen. 1. Het geding in feitelijke instantie...",
			"authorities": 0,
			"hubs": 0.0000488602462016726,
			"community": "4",
			"ecli": "ECLI:NL:HR:2004:AN8601",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2004-01-30",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.03634408602150538,
			"count_version": 4,
			"x": 0.1545284516917571,
			"y": 0.9113221343575445,
			"title": "ECLI:NL:HR:2004:AN8601 Hoge Raad , 30-01-2004 / C02/204HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 3,
			"degree": 3,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN7324",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "9 januari 2004 Eerste Kamer Nr. C02/199HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: MUNTENDAMSCHE INVESTERINGS MAATSCHAPPIJ B.V., gevestigd te 's-Gravenhage, EISERES tot cassatie, advocaat: mr. R.S. Meijer, t e g e n [Verweerder], wonende te [woonplaats], VERWEERDER in cassatie, advocaat: mr. D.G. Lasschuit. 1. Het geding in feitelijke instanties...",
			"authorities": 1.4688325974695944e-46,
			"hubs": 0,
			"community": "17",
			"ecli": "ECLI:NL:HR:2004:AN7324",
			"pagerank": 0.004654356987944911,
			"betweenness_centrality": 0,
			"date": "2004-01-09",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.013157894736842105,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.3114768551202747,
			"y": 0.18499657623192511,
			"title": "ECLI:NL:HR:2004:AN7324 Hoge Raad , 09-01-2004 / C02/199HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2004
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
			"out_degree_centrality": 0,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 194"
			],
			"in_degree": 3,
			"abstract": "\n         5 december 2003 Eerste Kamer Nr. C02/154HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: DE STICHTING NIEUW VREDENBURGH, gevestigd te Amsterdam, EISERES tot cassatie, advocaat: mr. M.J. Schenck, t e g e n NIEUWE HOLLANDSCHE LLOYD SCHADEVERZEKERING MAATSCHAPPIJ N.V., gevestigd te Woerden, VERWEERSTER in cassatie, advocaat: mr. J. van Duijvendijk-Brand. 1. Het geding in feitelijke instanties...",
			"authorities": 0.07610823628465141,
			"hubs": 0,
			"community": "0",
			"ecli": "ECLI:NL:HR:2003:AN8478",
			"pagerank": 0.006666384047121367,
			"betweenness_centrality": 0,
			"date": "2003-12-05",
			"in_degree_centrality": 0.01935483870967742,
			"rel_in_degree": 0.03896103896103896,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.8956221144219642,
			"y": 0.10352406340006681,
			"title": "ECLI:NL:HR:2003:AN8478 Hoge Raad , 05-12-2003 / C02/154HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 3,
			"year": 2003
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168",
			"out_degree_centrality": 0.03870967741935484,
			"degree_centrality": 0.03870967741935484,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "\n         31 oktober 2003 Eerste Kamer Nr. C02/234HR AT Hoge Raad der Nederlanden Arrest in de zaak van: 1. [Eiseres 1], 2. [Eiser 2], in hun hoedanigheid van ouders en wettelijk vertegenwoordigers van [betrokkene 1], beiden wonende te [woonplaats], EISERS tot cassatie, advocaat: mr. J. van Duijvendijk-Brand, t e g e n 1. [Verweerder 1], wonende te [woonplaats], 2. de rechtspersoonlijkheid bezittende VERENIGING VOOR CHRISTELIJK WETENSCHAPPELIJK ONDERWIJS, EXPLOITERENDE HET ACADEMISCH ZIEKENHUIS DER VRIJE UNIVERSITEIT \"AZVU\", gevestigd te Amsterdam, VERWEERDERS in cassatie,  advocaat: mr. E. van Staden ten Brink. 1. Het geding in feitelijke instanties...",
			"authorities": 0,
			"hubs": 5.963039245781266e-29,
			"community": "6",
			"ecli": "ECLI:NL:HR:2003:AL8168",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2003-10-31",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.03951612903225806,
			"count_version": 5,
			"x": 0.8668596830871635,
			"y": 0.42227972606206543,
			"title": "ECLI:NL:HR:2003:AL8168 Hoge Raad , 31-10-2003 / C02/234HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 6,
			"degree": 6,
			"year": 2003
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.04516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 3,
			"abstract": "\n         12 september 2003 Eerste Kamer Nr. C01/264HR RM/AT Hoge Raad der Nederlanden Arrest in de zaak van: [Eiseres], wonende te [woonplaats], EISERES tot cassatie, advocaat: aanvankelijk mr. M.E.M.G. Peletier, thans mr. A.G. Castermans, t e g e n [Verweerster], gevestigd te [vestigingsplaats], VERWEERSTER in cassatie, advocaat: mr. A.J. Swelheim. 1. Het geding in feitelijke instanties",
			"authorities": 0.053933909193476584,
			"hubs": 0.00008525950579802631,
			"community": "18",
			"ecli": "ECLI:NL:HR:2003:AF8254",
			"pagerank": 0.013440277432296619,
			"betweenness_centrality": 0.005320485965647256,
			"date": "2003-09-12",
			"in_degree_centrality": 0.01935483870967742,
			"rel_in_degree": 0.0379746835443038,
			"closeness_centrality": 0.04147465437788018,
			"count_version": 5,
			"x": 0.7036085266803882,
			"y": 0.942742634168722,
			"title": "ECLI:NL:HR:2003:AF8254 Hoge Raad , 12-09-2003 / C01/264HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 7,
			"year": 2003
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF5891",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "-",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "13",
			"ecli": "ECLI:NL:HR:2003:AF5891",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2003-06-06",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 3,
			"x": 0.043723474676954366,
			"y": 0.0811432917493854,
			"title": "ECLI:NL:HR:2003:AF5891 Hoge Raad , 06-06-2003 / C02/062HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2003
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "-",
			"authorities": 0.000023310458507731642,
			"hubs": 0,
			"community": "18",
			"ecli": "ECLI:NL:HR:2003:AF7000",
			"pagerank": 0.009957610980482973,
			"betweenness_centrality": 0,
			"date": "2003-05-16",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.024691358024691357,
			"closeness_centrality": 0,
			"count_version": 5,
			"x": 0.24041366098627248,
			"y": 0.7920497829260212,
			"title": "ECLI:NL:HR:2003:AF7000 Hoge Raad , 16-05-2003 / C01/156HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 2003
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF3422",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "28",
			"ecli": "ECLI:NL:HR:2003:AF3422",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "2003-04-11",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.012195121951219513,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.26935561758552684,
			"y": 0.6243906961842657,
			"title": "ECLI:NL:HR:2003:AF3422 Hoge Raad , 11-04-2003 / C01/248HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2003
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "-",
			"authorities": 3.9270186849238617e-29,
			"hubs": 0,
			"community": "6",
			"ecli": "ECLI:NL:HR:2003:AF0694",
			"pagerank": 0.006013834730631705,
			"betweenness_centrality": 0,
			"date": "2003-01-24",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.024096385542168676,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.7588493604793688,
			"y": 0.6111273025713577,
			"title": "ECLI:NL:HR:2003:AF0694 Hoge Raad , 24-01-2003 / C02/011HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 2003
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE9242",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 12a"
			],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 1.4688325974695944e-46,
			"hubs": 0,
			"community": "17",
			"ecli": "ECLI:NL:HR:2002:AE9242",
			"pagerank": 0.004654356987944911,
			"betweenness_centrality": 0,
			"date": "2002-12-06",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.011904761904761904,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.08621148957109903,
			"y": 0.7066429787465804,
			"title": "ECLI:NL:HR:2002:AE9242 Hoge Raad , 06-12-2002 / C01/110HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2002
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 150"
			],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 2.1464747059998783e-13,
			"hubs": 3.2770034786430284e-21,
			"community": "3",
			"ecli": "ECLI:NL:HR:2002:AE7345",
			"pagerank": 0.005223486315578651,
			"betweenness_centrality": 0.00033514872224549644,
			"date": "2002-11-29",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.011764705882352941,
			"closeness_centrality": 0.025806451612903226,
			"count_version": 7,
			"x": 0.4553269837434901,
			"y": 0.7916871623871047,
			"title": "ECLI:NL:HR:2002:AE7345 Hoge Raad , 29-11-2002 / C00/298HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 5,
			"year": 2002
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 150"
			],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 2.1464747059998783e-13,
			"hubs": 3.2770034786430284e-21,
			"community": "3",
			"ecli": "ECLI:NL:HR:2002:AE7351",
			"pagerank": 0.005223486315578651,
			"betweenness_centrality": 0.00033514872224549644,
			"date": "2002-11-29",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.011627906976744186,
			"closeness_centrality": 0.025806451612903226,
			"count_version": 6,
			"x": 0.45120811506416414,
			"y": 0.02213226706316007,
			"title": "ECLI:NL:HR:2002:AE7351 Hoge Raad , 29-11-2002 / C01/071HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 5,
			"year": 2002
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 1.570337572619915e-96,
			"hubs": 0.00003232123175810883,
			"community": "4",
			"ecli": "ECLI:NL:HR:2002:AE4080",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0.00008378718056137411,
			"date": "2002-10-04",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.011494252873563218,
			"closeness_centrality": 0.008602150537634409,
			"count_version": 4,
			"x": 0.23759920126366918,
			"y": 0.09579640561159242,
			"title": "ECLI:NL:HR:2002:AE4080 Hoge Raad , 04-10-2002 / C01/326HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 2,
			"year": 2002
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "-",
			"authorities": 0.00020578544181916691,
			"hubs": 0,
			"community": "18",
			"ecli": "ECLI:NL:HR:2002:AE4090",
			"pagerank": 0.00832623768925882,
			"betweenness_centrality": 0,
			"date": "2002-10-04",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.022727272727272728,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.5480542651649231,
			"y": 0.6470726656077117,
			"title": "ECLI:NL:HR:2002:AE4090 Hoge Raad , 04-10-2002 / C01/304HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 2002
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
			"out_degree_centrality": 0,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 3,
			"abstract": "-",
			"authorities": 0.010223604179452879,
			"hubs": 0,
			"community": "2",
			"ecli": "ECLI:NL:HR:2002:AE2113",
			"pagerank": 0.0075819393173567635,
			"betweenness_centrality": 0,
			"date": "2002-08-09",
			"in_degree_centrality": 0.01935483870967742,
			"rel_in_degree": 0.033707865168539325,
			"closeness_centrality": 0,
			"count_version": 6,
			"x": 0.6873754336764782,
			"y": 0.5461641253538062,
			"title": "ECLI:NL:HR:2002:AE2113 Hoge Raad , 09-08-2002 / C00/234HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 3,
			"year": 2002
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD9124",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Koophandel 391"
			],
			"in_degree": 0,
			"abstract": "-",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "25",
			"ecli": "ECLI:NL:HR:2002:AD9124",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2002-04-12",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 6,
			"x": 0.8666604221444575,
			"y": 0.3223098230131416,
			"title": "ECLI:NL:HR:2002:AD9124 Hoge Raad , 12-04-2002 / C00/207HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2002
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD7319",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 134"
			],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "11",
			"ecli": "ECLI:NL:HR:2002:AD7319",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "2002-03-01",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.01098901098901099,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.4253712128086302,
			"y": 0.10125354588366964,
			"title": "ECLI:NL:HR:2002:AD7319 Hoge Raad , 01-03-2002 / C00/063HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2002
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD4923",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "-",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "4",
			"ecli": "ECLI:NL:HR:2002:AD4923",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2002-01-18",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.026904598490048042,
			"count_version": 4,
			"x": 0.4595423028820401,
			"y": 0.9173863459092234,
			"title": "ECLI:NL:HR:2002:AD4923 Hoge Raad , 18-01-2002 / C00/103HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2002
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 177"
			],
			"in_degree": 2,
			"abstract": "-",
			"authorities": 2.8411354428361827e-21,
			"hubs": 0,
			"community": "3",
			"ecli": "ECLI:NL:HR:2001:AB2737",
			"pagerank": 0.006058570747168349,
			"betweenness_centrality": 0,
			"date": "2001-11-23",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.021505376344086023,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.6031371640983869,
			"y": 0.5238711176838718,
			"title": "ECLI:NL:HR:2001:AB2737 Hoge Raad , 23-11-2001 / C99/259HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 177"
			],
			"in_degree": 2,
			"abstract": "-",
			"authorities": 2.8411354428361827e-21,
			"hubs": 0,
			"community": "3",
			"ecli": "ECLI:NL:HR:2001:AD3963",
			"pagerank": 0.006058570747168349,
			"betweenness_centrality": 0,
			"date": "2001-11-23",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.02127659574468085,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.4160352248398296,
			"y": 0.29876891773725633,
			"title": "ECLI:NL:HR:2001:AD3963 Hoge Raad , 23-11-2001 / C00/069HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "-",
			"authorities": 0,
			"hubs": 0.000015188296082405083,
			"community": "4",
			"ecli": "ECLI:NL:HR:2001:ZC3677",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2001-11-09",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.033040078201368527,
			"count_version": 5,
			"x": 0.49857713019806515,
			"y": 0.5857557590280893,
			"title": "ECLI:NL:HR:2001:ZC3677 Hoge Raad , 09-11-2001 / C99/282HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 2,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "-",
			"authorities": 0.0023145702563165693,
			"hubs": 4.528120703550725e-97,
			"community": "18",
			"ecli": "ECLI:NL:HR:2001:ZC3689",
			"pagerank": 0.006607814408274016,
			"betweenness_centrality": 0.00020946795140343527,
			"date": "2001-10-19",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.020833333333333332,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 5,
			"x": 0.8897039917620493,
			"y": 0.3984237150269121,
			"title": "ECLI:NL:HR:2001:ZC3689 Hoge Raad , 19-10-2001 / C99/262HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 3,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2149",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 4,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 6.266963476646511e-57,
			"hubs": 0,
			"community": "7",
			"ecli": "ECLI:NL:HR:2001:AB2149",
			"pagerank": 0.00492625253648227,
			"betweenness_centrality": 0,
			"date": "2001-06-15",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.010309278350515464,
			"closeness_centrality": 0,
			"count_version": 8,
			"x": 0.36080378189365414,
			"y": 0.26790146310326446,
			"title": "ECLI:NL:HR:2001:AB2149 Hoge Raad , 15-06-2001 / C99/350HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1430",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 0,
			"abstract": "-",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "24",
			"ecli": "ECLI:NL:HR:2001:AB1430",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2001-05-04",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 4,
			"x": 0.8290499799148427,
			"y": 0.9479021746388284,
			"title": "ECLI:NL:HR:2001:AB1430 Hoge Raad , 04-05-2001 / C99/225HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1208",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 3.206397329479628e-29,
			"hubs": 0,
			"community": "6",
			"ecli": "ECLI:NL:HR:2001:AB1208",
			"pagerank": 0.004382461439407553,
			"betweenness_centrality": 0,
			"date": "2001-04-20",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.010101010101010102,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.15404510163594276,
			"y": 0.10327040101802198,
			"title": "ECLI:NL:HR:2001:AB1208 Hoge Raad , 20-04-2001 / C99/293HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 3.206397329479628e-29,
			"hubs": 4.528120703550725e-97,
			"community": "6",
			"ecli": "ECLI:NL:HR:2001:AB0900",
			"pagerank": 0.004382461439407553,
			"betweenness_centrality": 0.000041893590280687055,
			"date": "2001-04-06",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.01,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 4,
			"x": 0.007971281167574507,
			"y": 0.6434757037926354,
			"title": "ECLI:NL:HR:2001:AB0900 Hoge Raad , 06-04-2001 / C99/158HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 2,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "-",
			"authorities": 2.8411354428361827e-21,
			"hubs": 0,
			"community": "3",
			"ecli": "ECLI:NL:HR:2001:AB0377",
			"pagerank": 0.006058570747168349,
			"betweenness_centrality": 0,
			"date": "2001-03-02",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.019801980198019802,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.18561958087508512,
			"y": 0.030940394683492856,
			"title": "ECLI:NL:HR:2001:AB0377 Hoge Raad , 02-03-2001 / C99/089HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 177"
			],
			"in_degree": 2,
			"abstract": "-",
			"authorities": 2.8411354428361827e-21,
			"hubs": 0,
			"community": "3",
			"ecli": "ECLI:NL:HR:2001:AA9556",
			"pagerank": 0.006058570747168349,
			"betweenness_centrality": 0,
			"date": "2001-01-19",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.0196078431372549,
			"closeness_centrality": 0,
			"count_version": 6,
			"x": 0.8316059939891546,
			"y": 0.0021252289399460444,
			"title": "ECLI:NL:HR:2001:AA9556 Hoge Raad , 19-01-2001 / C99/093HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 3,
			"abstract": "-",
			"authorities": 0.010223604179452879,
			"hubs": 0.0023150403857461303,
			"community": "2",
			"ecli": "ECLI:NL:HR:2001:AA9434",
			"pagerank": 0.0075819393173567635,
			"betweenness_centrality": 0.000397989107666527,
			"date": "2001-01-12",
			"in_degree_centrality": 0.01935483870967742,
			"rel_in_degree": 0.02912621359223301,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 5,
			"x": 0.1312350272933649,
			"y": 0.8835968177295939,
			"title": "ECLI:NL:HR:2001:AA9434 Hoge Raad , 12-01-2001 / C99/125HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 5,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9308",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Verdrag betreffende de overeenkomst tot internationaal vervoer van goederen over de weg (CMR), Genève, 19-05-1956 29"
			],
			"in_degree": 0,
			"abstract": "-",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "9",
			"ecli": "ECLI:NL:HR:2001:AA9308",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2001-01-05",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 4,
			"x": 0.164449979791072,
			"y": 0.29738009807316934,
			"title": "ECLI:NL:HR:2001:AA9308 Hoge Raad , 05-01-2001 / C99/162HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9313",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 1.4688325974695944e-46,
			"hubs": 0,
			"community": "17",
			"ecli": "ECLI:NL:HR:2001:AA9313",
			"pagerank": 0.004654356987944911,
			"betweenness_centrality": 0,
			"date": "2001-01-05",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.009523809523809525,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.05845507881094991,
			"y": 0.5550271565320134,
			"title": "ECLI:NL:HR:2001:AA9313 Hoge Raad , 05-01-2001 / C99/122HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9243",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 4,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wet op de loonbelasting 1964 10"
			],
			"in_degree": 1,
			"abstract": "Nr. 35438 3 januari 2001 gewezen op het beroep in cassatie van de Staatssecretaris van Financiën tegen de uitspraak van het Gerechtshof te Arnhem van 3 juni 1999, nr. 97/22511, betreffende na te melden aan de besloten vennootschap met beperkte aansprakelijkheid X te Z opgelegde naheffingsaanslag loonbelasting/premie volksverzekeringen. 1. Naheffingsaanslag, bezwaar en geding voor het Hof...",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "16",
			"ecli": "ECLI:NL:HR:2001:AA9243",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "2001-01-03",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.009433962264150943,
			"closeness_centrality": 0,
			"count_version": 10,
			"x": 0.7462409452640355,
			"y": 0.691568938079569,
			"title": "ECLI:NL:HR:2001:AA9243 Hoge Raad , 03-01-2001 / 35438",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#bestuursrecht_belastingrecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2001
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 1.570337572619915e-96,
			"hubs": 0.000015188296082405083,
			"community": "4",
			"ecli": "ECLI:NL:HR:2000:AA9051",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0.0005446166736489317,
			"date": "2000-12-15",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.009345794392523364,
			"closeness_centrality": 0.033040078201368527,
			"count_version": 5,
			"x": 0.7299803016070618,
			"y": 0.01606794114993404,
			"title": "ECLI:NL:HR:2000:AA9051 Hoge Raad , 15-12-2000 / C99/139HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 3,
			"year": 2000
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9048",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "24",
			"ecli": "ECLI:NL:HR:2000:AA9048",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "2000-12-15",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.009259259259259259,
			"closeness_centrality": 0,
			"count_version": 5,
			"x": 0.0403612591052781,
			"y": 0.24686162819807644,
			"title": "ECLI:NL:HR:2000:AA9048 Hoge Raad , 15-12-2000 / C99/074HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2000
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.04516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 5",
				"Wet op de rechterlijke organisatie 39",
				"Wetboek van Burgerlijke Rechtsvordering 157",
				"Overgangswet nieuw Burgerlijk Wetboek 74",
				"Wetboek van Burgerlijke Rechtsvordering 140",
				"Overgangswet nieuw Burgerlijk Wetboek 69",
				"Overgangswet nieuw Burgerlijk Wetboek 68a"
			],
			"in_degree": 6,
			"abstract": "-",
			"authorities": 0.19498600591376608,
			"hubs": 0.000012968485017164284,
			"community": "0",
			"ecli": "ECLI:NL:HR:2000:AA8369",
			"pagerank": 0.016111981596177855,
			"betweenness_centrality": 0.0027649769585253456,
			"date": "2000-11-17",
			"in_degree_centrality": 0.03870967741935484,
			"rel_in_degree": 0.05504587155963303,
			"closeness_centrality": 0.02903225806451613,
			"count_version": 5,
			"x": 0.8488267209364493,
			"y": 0.7511431226721579,
			"title": "ECLI:NL:HR:2000:AA8369 Hoge Raad , 17-11-2000 / C98/273HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 7,
			"year": 2000
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8364",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 177"
			],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 6.266963476646511e-57,
			"hubs": 0,
			"community": "7",
			"ecli": "ECLI:NL:HR:2000:AA8364",
			"pagerank": 0.00492625253648227,
			"betweenness_centrality": 0,
			"date": "2000-11-17",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.00909090909090909,
			"closeness_centrality": 0,
			"count_version": 5,
			"x": 0.15335817721558853,
			"y": 0.9556009834459628,
			"title": "ECLI:NL:HR:2000:AA8364 Hoge Raad , 17-11-2000 / C99/016",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2000
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA7686",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Grondwet 121",
				"Wetboek van Burgerlijke Rechtsvordering 59",
				"Wetboek van Burgerlijke Rechtsvordering 176",
				"Wetboek van Burgerlijke Rechtsvordering 177"
			],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 6.266963476646511e-57,
			"hubs": 0,
			"community": "7",
			"ecli": "ECLI:NL:HR:2000:AA7686",
			"pagerank": 0.00492625253648227,
			"betweenness_centrality": 0,
			"date": "2000-10-20",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.009009009009009009,
			"closeness_centrality": 0,
			"count_version": 5,
			"x": 0.08874477390771673,
			"y": 0.25600282205465363,
			"title": "ECLI:NL:HR:2000:AA7686 Hoge Raad , 20-10-2000 / C99/004HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 2000
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.025806451612903226,
			"count_annotation": 5,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "-",
			"authorities": 2.860406296671996e-13,
			"hubs": 1.3401624883961085e-29,
			"community": "8",
			"ecli": "ECLI:NL:HR:2000:AA5635",
			"pagerank": 0.006516857305061262,
			"betweenness_centrality": 0.00025136154168412233,
			"date": "2000-04-28",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.017857142857142856,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 9,
			"x": 0.09077143273606125,
			"y": 0.5569529114350582,
			"title": "ECLI:NL:HR:2000:AA5635 Hoge Raad , 28-04-2000 / C98/363HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 4,
			"year": 2000
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5634",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Onteigeningswet 73"
			],
			"in_degree": 0,
			"abstract": "-",
			"authorities": 0,
			"hubs": 4.528120703550725e-97,
			"community": "8",
			"ecli": "ECLI:NL:HR:2000:AA5634",
			"pagerank": 0.0038386703423328346,
			"betweenness_centrality": 0,
			"date": "2000-04-28",
			"in_degree_centrality": 0,
			"rel_in_degree": 0,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 5,
			"x": 0.4335141987424399,
			"y": 0.8291632847446144,
			"title": "ECLI:NL:HR:2000:AA5634 Hoge Raad , 28-04-2000 / C98/220HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 1,
			"year": 2000
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.05806451612903226,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Overgangswet nieuw Burgerlijk Wetboek 74",
				"Overgangswet nieuw Burgerlijk Wetboek 69",
				"Overgangswet nieuw Burgerlijk Wetboek 68a"
			],
			"in_degree": 5,
			"abstract": "-",
			"authorities": 0.0000449742853949153,
			"hubs": 6.872489035210302e-14,
			"community": "4",
			"ecli": "ECLI:NL:HR:1999:AA3837",
			"pagerank": 0.02612714245389464,
			"betweenness_centrality": 0.009069962295768747,
			"date": "1999-12-10",
			"in_degree_centrality": 0.03225806451612903,
			"rel_in_degree": 0.043859649122807015,
			"closeness_centrality": 0.039032258064516136,
			"count_version": 5,
			"x": 0.3334175237996283,
			"y": 0.1416713399258165,
			"title": "ECLI:NL:HR:1999:AA3837 Hoge Raad , 10-12-1999 / C98/202HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 9,
			"year": 1999
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3835",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 178"
			],
			"in_degree": 1,
			"abstract": "-",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "6",
			"ecli": "ECLI:NL:HR:1999:AA3835",
			"pagerank": 0.007563670976565536,
			"betweenness_centrality": 0,
			"date": "1999-12-10",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.008695652173913044,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.5865694196112933,
			"y": 0.6834393695961981,
			"title": "ECLI:NL:HR:1999:AA3835 Hoge Raad , 10-12-1999 / C98/158HR",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1999
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC2912",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "13",
			"ecli": "ECLI:NL:HR:1999:ZC2912",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "1999-05-28",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.008620689655172414,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.9526664041473041,
			"y": 0.1421355950169223,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1999
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "",
			"authorities": 0.0015315162764184982,
			"hubs": 0,
			"community": "2",
			"ecli": "ECLI:NL:HR:1999:AD2996",
			"pagerank": 0.008268229337810198,
			"betweenness_centrality": 0,
			"date": "1999-01-22",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.017094017094017096,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.764000253645824,
			"y": 0.4256072005379581,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 2,
			"year": 1999
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD299",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 0.002130391829413503,
			"hubs": 0,
			"community": "2",
			"ecli": "ECLI:NL:HR:1999:AD299",
			"pagerank": 0.004976441117049863,
			"betweenness_centrality": 0,
			"date": "",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.00847457627118644,
			"closeness_centrality": 0,
			"count_version": 0,
			"x": 0.6584333224413725,
			"y": 0.03288225662594868,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1999
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC293",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 3.206397329479628e-29,
			"hubs": 0,
			"community": "6",
			"ecli": "ECLI:NL:HR:1999:ZC293",
			"pagerank": 0.004382461439407553,
			"betweenness_centrality": 0,
			"date": "",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.008403361344537815,
			"closeness_centrality": 0,
			"count_version": 0,
			"x": 0.9178984612332374,
			"y": 0.6475743830317576,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1999
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2748",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 3.206397329479628e-29,
			"hubs": 0,
			"community": "6",
			"ecli": "ECLI:NL:HR:1998:ZC2748",
			"pagerank": 0.004382461439407553,
			"betweenness_centrality": 0,
			"date": "1998-10-23",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.008333333333333333,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.10496502829044219,
			"y": 0.6894742243761094,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1998
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 134"
			],
			"in_degree": 4,
			"abstract": "",
			"authorities": 8.061615055298676e-13,
			"hubs": 4.7372917196627155e-14,
			"community": "8",
			"ecli": "ECLI:NL:HR:1998:ZC2721",
			"pagerank": 0.008989255472456515,
			"betweenness_centrality": 0.00020946795140343527,
			"date": "1998-10-02",
			"in_degree_centrality": 0.025806451612903226,
			"rel_in_degree": 0.03305785123966942,
			"closeness_centrality": 0.008602150537634409,
			"count_version": 4,
			"x": 0.8876215917826925,
			"y": 0.23824563311530755,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 1,
			"degree": 5,
			"year": 1998
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.570337572619915e-96,
			"hubs": 3.1087952108284664e-13,
			"community": "8",
			"ecli": "ECLI:NL:HR:1998:ZC2720",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0.00012568077084206116,
			"date": "1998-10-02",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.00819672131147541,
			"closeness_centrality": 0.014516129032258065,
			"count_version": 5,
			"x": 0.7480680586687117,
			"y": 0.9209738500532405,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 3,
			"year": 1998
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC272",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 0.048655896835773274,
			"hubs": 0,
			"community": "0",
			"ecli": "ECLI:NL:HR:1998:ZC272",
			"pagerank": 0.004382461439407553,
			"betweenness_centrality": 0,
			"date": "",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.008130081300813009,
			"closeness_centrality": 0,
			"count_version": 0,
			"x": 0.060488527294226824,
			"y": 0.3394969834521663,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1998
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2495",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 48",
				"Wetboek van Burgerlijke Rechtsvordering 176"
			],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "10",
			"ecli": "ECLI:NL:HR:1997:ZC2495",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "1997-11-14",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.008064516129032258,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.4527595127483479,
			"y": 0.12394449287152542,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1997
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2460",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 2.3802363410719314e-14,
			"hubs": 0,
			"community": "4",
			"ecli": "ECLI:NL:HR:1997:ZC2460",
			"pagerank": 0.009390030667047345,
			"betweenness_centrality": 0,
			"date": "1997-10-17",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.008,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.3742220147021128,
			"y": 0.7049533076298207,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1997
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:1996:AD4440",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 7.206213554442336e-30,
			"hubs": 0,
			"community": "8",
			"ecli": "ECLI:NL:XX:1996:AD4440",
			"pagerank": 0.006608302288824469,
			"betweenness_centrality": 0,
			"date": "1996-10-22",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007936507936507936,
			"closeness_centrality": 0,
			"count_version": 1,
			"x": 0.39573650419425854,
			"y": 0.3243718322586081,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1996
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142",
			"out_degree_centrality": 0.025806451612903226,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 177"
			],
			"in_degree": 1,
			"abstract": "",
			"authorities": 2.3802363410719314e-14,
			"hubs": 1.4680845323233493e-31,
			"community": "4",
			"ecli": "ECLI:NL:HR:1996:ZC2142",
			"pagerank": 0.009390030667047345,
			"betweenness_centrality": 0.005152911604524508,
			"date": "1996-09-20",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007874015748031496,
			"closeness_centrality": 0.028739002932551317,
			"count_version": 4,
			"x": 0.39570405804068753,
			"y": 0.8106474849214197,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 4,
			"degree": 5,
			"year": 1996
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "",
			"authorities": 3.9270186849238617e-29,
			"hubs": 0,
			"community": "8",
			"ecli": "ECLI:NL:HR:1995:ZC1867",
			"pagerank": 0.007152093385899186,
			"betweenness_centrality": 0,
			"date": "1995-11-03",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.015625,
			"closeness_centrality": 0,
			"count_version": 2,
			"x": 0.37689023126529,
			"y": 0.2817534689512574,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 1995
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1994:ZC1405",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "18",
			"ecli": "ECLI:NL:HR:1994:ZC1405",
			"pagerank": 0.009455196098058734,
			"betweenness_centrality": 0,
			"date": "1994-06-24",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007751937984496124,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.6315904256880831,
			"y": 0.7949675052678337,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1994
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1076",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "23",
			"ecli": "ECLI:NL:HR:1993:ZC1076",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "1993-09-24",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007692307692307693,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.43704883002082806,
			"y": 0.5634085866670117,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1993
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AC4282",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "16",
			"ecli": "ECLI:NL:HR:1993:AC4282",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "1993-07-15",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007633587786259542,
			"closeness_centrality": 0,
			"count_version": 1,
			"x": 0.553475153118043,
			"y": 0.41520232562943327,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1993
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1044",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 157"
			],
			"in_degree": 1,
			"abstract": "",
			"authorities": 0.000012382480237382965,
			"hubs": 0,
			"community": "4",
			"ecli": "ECLI:NL:HR:1993:ZC1044",
			"pagerank": 0.00492625253648227,
			"betweenness_centrality": 0,
			"date": "1993-07-08",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007575757575757576,
			"closeness_centrality": 0,
			"count_version": 2,
			"x": 0.2347910501985635,
			"y": 0.1037750981782507,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1993
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Burgerlijke Rechtsvordering 4",
				"Wetboek van Burgerlijke Rechtsvordering 5"
			],
			"in_degree": 2,
			"abstract": "",
			"authorities": 0.000007698232772663564,
			"hubs": 0,
			"community": "4",
			"ecli": "ECLI:NL:HR:1993:ZC1027",
			"pagerank": 0.008488179080134325,
			"betweenness_centrality": 0,
			"date": "1993-07-01",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.015037593984962405,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.3723070366438761,
			"y": 0.09069414394403308,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 1993
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.03870967741935484,
			"count_annotation": 3,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Burgerlijk Wetboek Boek 7A 1638x",
				"Burgerlijk Wetboek Boek 7A"
			],
			"in_degree": 5,
			"abstract": "",
			"authorities": 9.138323552009703e-13,
			"hubs": 4.7372917196627155e-14,
			"community": "8",
			"ecli": "ECLI:NL:HR:1993:AD1907",
			"pagerank": 0.01200739091903385,
			"betweenness_centrality": 0.00020946795140343527,
			"date": "1993-06-25",
			"in_degree_centrality": 0.03225806451612903,
			"rel_in_degree": 0.03731343283582089,
			"closeness_centrality": 0.008602150537634409,
			"count_version": 7,
			"x": 0.586302705564782,
			"y": 0.932751381465059,
			"title": "",
			"subject": "",
			"out_degree": 1,
			"degree": 6,
			"year": 1993
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "",
			"authorities": 0.006496968690907915,
			"hubs": 0,
			"community": "2",
			"ecli": "ECLI:NL:HR:1992:ZC0717",
			"pagerank": 0.008850786713874088,
			"betweenness_centrality": 0,
			"date": "1992-10-16",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.014814814814814815,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.6467415657200369,
			"y": 0.7229437348953757,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 2,
			"year": 1992
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 8.485449232399809e-32,
			"hubs": 9.787230215488994e-32,
			"community": "4",
			"ecli": "ECLI:NL:HR:1992:ZC0559",
			"pagerank": 0.005832839607977089,
			"betweenness_centrality": 0,
			"date": "1992-03-27",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007352941176470588,
			"closeness_centrality": 0.012903225806451613,
			"count_version": 4,
			"x": 0.928866552263389,
			"y": 0.6852053090775568,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 3,
			"year": 1992
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0526",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 4,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "26",
			"ecli": "ECLI:NL:HR:1992:ZC0526",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "1992-02-28",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.0072992700729927005,
			"closeness_centrality": 0,
			"count_version": 6,
			"x": 0.23094847617853298,
			"y": 0.7467858794702896,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1992
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0394",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "25",
			"ecli": "ECLI:NL:HR:1991:ZC0394",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "1991-11-01",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007246376811594203,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.13657031592497526,
			"y": 0.7108171237299447,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1991
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0352",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "21",
			"ecli": "ECLI:NL:HR:1991:ZC0352",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "1991-10-04",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007194244604316547,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.7477434335526444,
			"y": 0.8594585027337064,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1991
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181",
			"out_degree_centrality": 0.012903225806451613,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 8.485449232399809e-32,
			"hubs": 0.0003287911887241735,
			"community": "4",
			"ecli": "ECLI:NL:HR:1991:ZC0181",
			"pagerank": 0.005832839607977089,
			"betweenness_centrality": 0.0017595307917888563,
			"date": "1991-03-22",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.007142857142857143,
			"closeness_centrality": 0.014516129032258065,
			"count_version": 2,
			"x": 0.9957765104024623,
			"y": 0.7503680159650892,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 2,
			"degree": 3,
			"year": 1991
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC0073",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "21",
			"ecli": "ECLI:NL:HR:1990:ZC0073",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "1990-12-07",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.0070921985815602835,
			"closeness_centrality": 0,
			"count_version": 4,
			"x": 0.7101989631849347,
			"y": 0.6864858078948198,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1990
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 4,
			"abstract": "",
			"authorities": 0.00011208898336856304,
			"hubs": 7.624991590142904e-15,
			"community": "4",
			"ecli": "ECLI:NL:HR:1990:AC4217",
			"pagerank": 0.018089592653702944,
			"betweenness_centrality": 0.00027230833682446586,
			"date": "1990-06-15",
			"in_degree_centrality": 0.025806451612903226,
			"rel_in_degree": 0.028169014084507043,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 4,
			"x": 0.9006156798251723,
			"y": 0.38180959175118445,
			"title": "",
			"subject": "",
			"out_degree": 1,
			"degree": 5,
			"year": 1990
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.03225806451612903,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 4,
			"abstract": "",
			"authorities": 1.6428774025423316e-13,
			"hubs": 4.528120703550725e-97,
			"community": "8",
			"ecli": "ECLI:NL:HR:1990:AB9376",
			"pagerank": 0.030254825181558538,
			"betweenness_centrality": 0.0012568077084206116,
			"date": "1990-04-06",
			"in_degree_centrality": 0.025806451612903226,
			"rel_in_degree": 0.027972027972027972,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 3,
			"x": 0.5787996600431016,
			"y": 0.9681331325515409,
			"title": "",
			"subject": "",
			"out_degree": 1,
			"degree": 5,
			"year": 1990
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC8398",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [
				"Wetboek van Strafvordering 457"
			],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "8",
			"ecli": "ECLI:NL:HR:1990:ZC8398",
			"pagerank": 0.02955118866842518,
			"betweenness_centrality": 0,
			"date": "1990-01-30",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.006944444444444444,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.12688126041572934,
			"y": 0.743910364955935,
			"title": "",
			"subject": "http://psi.rechtspraak.nl/rechtsgebied#strafrecht",
			"out_degree": 0,
			"degree": 1,
			"year": 1990
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "",
			"authorities": 0.0010281481944855258,
			"hubs": 0,
			"community": "4",
			"ecli": "ECLI:NL:HR:1989:AB9375",
			"pagerank": 0.007523485007228277,
			"betweenness_centrality": 0,
			"date": "1989-11-17",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.013793103448275862,
			"closeness_centrality": 0,
			"count_version": 2,
			"x": 0.5932784430875809,
			"y": 0.19430264286430665,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 2,
			"year": 1989
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AD0808",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.570337572619915e-96,
			"hubs": 0,
			"community": "9",
			"ecli": "ECLI:NL:HR:1989:AD0808",
			"pagerank": 0.007101416924781142,
			"betweenness_centrality": 0,
			"date": "1989-05-26",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.00684931506849315,
			"closeness_centrality": 0,
			"count_version": 3,
			"x": 0.4727261060460959,
			"y": 0.07630462043826525,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1989
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AC3826",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.4688325974695944e-46,
			"hubs": 0,
			"community": "17",
			"ecli": "ECLI:NL:HR:1987:AC3826",
			"pagerank": 0.004654356987944911,
			"betweenness_centrality": 0,
			"date": "1987-11-13",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.006802721088435374,
			"closeness_centrality": 0,
			"count_version": 1,
			"x": 0.4606356328072061,
			"y": 0.7042984049696792,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1987
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
			"out_degree_centrality": 0.0064516129032258064,
			"degree_centrality": 0.025806451612903226,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 3,
			"abstract": "",
			"authorities": 1.6970898464799618e-31,
			"hubs": 4.893615107744497e-32,
			"community": "4",
			"ecli": "ECLI:NL:HR:1987:AG5504",
			"pagerank": 0.011573146676689903,
			"betweenness_centrality": 0.000041893590280687055,
			"date": "1987-01-09",
			"in_degree_centrality": 0.01935483870967742,
			"rel_in_degree": 0.02027027027027027,
			"closeness_centrality": 0.0064516129032258064,
			"count_version": 2,
			"x": 0.34457852431994485,
			"y": 0.6677713378865175,
			"title": "",
			"subject": "",
			"out_degree": 1,
			"degree": 4,
			"year": 1987
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1983:AG4611",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 0.00002160701491610053,
			"hubs": 0,
			"community": "18",
			"ecli": "ECLI:NL:HR:1983:AG4611",
			"pagerank": 0.006694864398034667,
			"betweenness_centrality": 0,
			"date": "1983-06-10",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.006711409395973154,
			"closeness_centrality": 0,
			"count_version": 2,
			"x": 0.17610574050472128,
			"y": 0.6369900138778088,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1983
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AC0442",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "10",
			"ecli": "ECLI:NL:HR:1982:AC0442",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "1982-10-29",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.006666666666666667,
			"closeness_centrality": 0,
			"count_version": 2,
			"x": 0.7515203459846401,
			"y": 0.03957403848943408,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1982
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
			"out_degree_centrality": 0,
			"degree_centrality": 0.012903225806451613,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 2,
			"abstract": "",
			"authorities": 2.6443223511076045e-14,
			"hubs": 0,
			"community": "4",
			"ecli": "ECLI:NL:HR:1982:AG4420",
			"pagerank": 0.02476957016265319,
			"betweenness_centrality": 0,
			"date": "1982-06-25",
			"in_degree_centrality": 0.012903225806451613,
			"rel_in_degree": 0.013245033112582781,
			"closeness_centrality": 0,
			"count_version": 2,
			"x": 0.5397319566424933,
			"y": 0.8124435260765773,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 2,
			"year": 1982
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1978:AC3514",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 0,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "0",
			"ecli": "ECLI:NL:HR:1978:AC3514",
			"pagerank": 0.006394551737125777,
			"betweenness_centrality": 0,
			"date": "1978-04-14",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.006578947368421052,
			"closeness_centrality": 0,
			"count_version": 1,
			"x": 0.0022677864890102706,
			"y": 0.6459125559773297,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1978
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1976:AC5837",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 2,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "19",
			"ecli": "ECLI:NL:HR:1976:AC5837",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "1976-12-17",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.006535947712418301,
			"closeness_centrality": 0,
			"count_version": 2,
			"x": 0.5081816608015803,
			"y": 0.6573264559156063,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1976
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
			"out_degree_centrality": 0,
			"degree_centrality": 0.01935483870967742,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 3,
			"abstract": "",
			"authorities": 1.6970898464799616e-31,
			"hubs": 0,
			"community": "4",
			"ecli": "ECLI:NL:HR:1975:AC5607",
			"pagerank": 0.018149548170559658,
			"betweenness_centrality": 0,
			"date": "1975-06-27",
			"in_degree_centrality": 0.01935483870967742,
			"rel_in_degree": 0.01948051948051948,
			"closeness_centrality": 0,
			"count_version": 1,
			"x": 0.09178559256874264,
			"y": 0.5138500146869134,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 3,
			"year": 1975
		},
		{
			"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1969:AC4973",
			"out_degree_centrality": 0,
			"degree_centrality": 0.0064516129032258064,
			"count_annotation": 1,
			"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
			"articles": [],
			"in_degree": 1,
			"abstract": "",
			"authorities": 1.5187373096409423e-71,
			"hubs": 0,
			"community": "19",
			"ecli": "ECLI:NL:HR:1969:AC4973",
			"pagerank": 0.005470043633556988,
			"betweenness_centrality": 0,
			"date": "1969-11-28",
			"in_degree_centrality": 0.0064516129032258064,
			"rel_in_degree": 0.0064516129032258064,
			"closeness_centrality": 0,
			"count_version": 1,
			"x": 0.11058236354021633,
			"y": 0.2647051010504401,
			"title": "",
			"subject": "",
			"out_degree": 0,
			"degree": 1,
			"year": 1969
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/data.json
 ** module id = 448
 ** module chunks = 0
 **/